import { shallowReactive as Ce, watch as K, onBeforeUnmount as G, onMounted as M, ref as $, shallowRef as U, watchEffect as be, triggerRef as se, unref as w, isRef as ke, defineComponent as h, computed as S, resolveComponent as y, openBlock as i, createElementBlock as u, normalizeClass as a, createVNode as C, createCommentVNode as d, Fragment as _, renderList as D, createBlock as g, resolveDynamicComponent as T, normalizeProps as z, mergeProps as H, withCtx as F, normalizeStyle as I, createElementVNode as p, onUnmounted as O, guardReactiveProps as ne, withDirectives as P, vShow as E, toDisplayString as R, vModelRadio as x, vModelCheckbox as oe, vModelSelect as fe, onUpdated as te, vModelText as we, getCurrentInstance as ie, createStaticVNode as Ie, resolveDirective as X, toRaw as Se, Teleport as Re, useSlots as Te, renderSlot as $e } from "vue";
import { Base as _e, RendererFactory as ee, DropdownListModel as De, Helpers as Be, DropdownMultiSelectListModel as Le, doKey2ClickUp as ye, createSvg as Ne, ActionDropdownViewModel as Pe, getActionDropdownButtonTarget as Ae, createPopupViewModel as Me, SurveyProgressModel as de, ProgressButtonsResponsivityManager as Ee, PopupSurveyModel as He, settings as j, createDialogOptions as We, createPopupModalViewModel as Ve, ButtonGroupItemModel as Fe, SvgRegistry as Oe, SurveyModel as ze, doKey2ClickDown as Ue, doKey2ClickBlur as Ke } from "survey-core";
_e.createPropertiesHash = () => Ce({});
function Qe(r) {
  var s;
  !r || (r.__vueImplemented = (s = r.__vueImplemented) != null ? s : 0, r.__vueImplemented <= 0 && (r.createArrayCoreHandler = (n, e) => {
    const o = [], t = U(o);
    return o.onArrayChanged = () => {
      se(t);
    }, n[e] = t, w(n[e]);
  }, r.iteratePropertiesHash((n, e) => {
    if (Array.isArray(n[e])) {
      const o = U(n[e]);
      n[e].onArrayChanged = () => {
        se(o);
      }, n[e] = o;
    }
  }), r.getPropertyValueCoreHandler = (n, e) => w(n[e]), r.setPropertyValueCoreHandler = (n, e, o) => {
    ke(n[e]) ? n[e].value = o : n[e] = o;
  }), r.__vueImplemented++);
}
function me(r) {
  var s;
  !r || (r.__vueImplemented = (s = r.__vueImplemented) != null ? s : 0, r.__vueImplemented--, r.__vueImplemented <= 0 && (r.iteratePropertiesHash((n, e) => {
    n[e] = w(n[e]), Array.isArray(n[e]) && (n[e].onArrayChanged = void 0);
  }), delete r.__vueImplemented, r.createArrayCoreHandler = void 0, r.getPropertyValueCoreHandler = void 0, r.setPropertyValueCoreHandler = void 0));
}
function B(r, s, n) {
  const e = K(
    r,
    (o, t) => {
      o && s && s(o, t), t && (me(t), n && n(t)), Qe(o);
    },
    {
      immediate: !0
    }
  );
  G(() => {
    const o = r();
    o && (me(o), n && n(o), e());
  });
}
function A(r, s, n, e) {
  B(() => r.question, n, e), M(() => {
    r.question && r.question.afterRenderQuestionElement(s.value);
  }), G(() => {
    r.question.beforeDestroyQuestionElement(s.value);
  });
}
function J(r) {
  const s = $(), n = (o) => {
    s.value = o.renderedHtml, o.onChanged = () => {
      s.value = o.renderedHtml;
    };
  }, e = K(
    r,
    (o, t) => {
      t && (t.onChanged = () => {
      }), n(o);
    },
    { immediate: !0 }
  );
  return G(() => {
    e();
  }), s;
}
function re(r) {
  return r.customWidget ? "survey-customwidget" : r.isDefaultRendering && r.isDefaultRendering() || r.isPanel ? "survey-" + r.getTemplate() : r.getComponentName();
}
function le(r) {
  const s = U(), n = be(() => {
    s.value = r(), se(s);
  });
  return G(() => {
    n();
  }), s;
}
const je = /* @__PURE__ */ h({
  __name: "Page",
  props: {
    survey: {},
    page: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(null), e = () => {
      s.survey && n.value && s.survey.afterRenderPage(n.value);
    }, o = S(() => s.page._showDescription);
    return B(
      () => s.page,
      () => {
        e();
      }
    ), M(() => {
      e();
    }), (t, l) => {
      const m = y("survey-element-title"), v = y("survey-string"), c = y("survey-errors"), q = y("survey-row");
      return i(), u("div", {
        class: a(t.page.cssRoot),
        ref_key: "root",
        ref: n
      }, [
        C(m, {
          element: t.page,
          css: t.css
        }, null, 8, ["element", "css"]),
        o.value ? (i(), u("div", {
          key: 0,
          class: a(t.page.cssClasses.page.description)
        }, [
          C(v, {
            locString: t.page.locDescription
          }, null, 8, ["locString"])
        ], 2)) : d("", !0),
        C(c, { element: t.page }, null, 8, ["element"]),
        (i(!0), u(_, null, D(t.page.visibleRows, (f) => (i(), g(T(t.page.getSurvey().getRowWrapperComponentName(f)), z(H({
          key: f.id
        }, {
          componentData: t.page.getSurvey().getRowWrapperComponentData(f)
        })), {
          default: F(() => [
            C(q, {
              row: f,
              survey: t.survey,
              css: t.css
            }, null, 8, ["row", "survey", "css"])
          ]),
          _: 2
        }, 1040))), 128))
      ], 2);
    };
  }
}), Ge = /* @__PURE__ */ h({
  __name: "Header",
  props: {
    survey: {}
  },
  setup(r) {
    const s = r, n = $();
    return M(() => {
      var e = n.value;
      e && s.survey && s.survey.afterRenderHeader(e);
    }), (e, o) => {
      const t = y("survey-element-title"), l = y("survey-string");
      return e.survey.renderedHasHeader ? (i(), u("div", {
        key: 0,
        class: a(e.survey.css.header),
        ref_key: "root",
        ref: n
      }, [
        e.survey.isLogoBefore ? (i(), g(T(e.survey.getElementWrapperComponentName(e.survey, "logo-image")), {
          key: 0,
          data: e.survey.getElementWrapperComponentData(e.survey, "logo-image")
        }, null, 8, ["data"])) : d("", !0),
        e.survey.renderedHasTitle ? (i(), u("div", {
          key: 1,
          class: a(e.survey.css.headerText),
          style: I({ maxWidth: e.survey.titleMaxWidth })
        }, [
          C(t, {
            element: e.survey,
            css: e.survey.css
          }, null, 8, ["element", "css"]),
          e.survey.renderedHasDescription ? (i(), u("div", {
            key: 0,
            class: a(e.survey.css.description)
          }, [
            C(l, {
              locString: e.survey.locDescription
            }, null, 8, ["locString"])
          ], 2)) : d("", !0)
        ], 6)) : d("", !0),
        e.survey.isLogoAfter ? (i(), g(T(e.survey.getElementWrapperComponentName(e.survey, "logo-image")), {
          key: 2,
          data: e.survey.getElementWrapperComponentData(e.survey, "logo-image")
        }, null, 8, ["data"])) : d("", !0),
        p("div", {
          class: a(e.survey.css.headerClose)
        }, null, 2)
      ], 2)) : d("", !0);
    };
  }
}), Je = /* @__PURE__ */ h({
  __name: "Row",
  props: {
    row: {},
    css: {},
    survey: {}
  },
  setup(r) {
    const s = r, n = $();
    return B(
      () => s.row,
      (e, o) => {
        e.setRootElement(n.value), o && (e.isNeedRender = o.isNeedRender);
      },
      (e) => {
        e.setRootElement(void 0), e.stopLazyRendering(), e.isNeedRender = !e.isLazyRendering();
      }
    ), M(() => {
      if (s.row && (s.row.setRootElement(n.value), !s.row.isNeedRender)) {
        const e = n.value;
        setTimeout(() => {
          s.row.startLazyRendering(e);
        }, 10);
      }
    }), (e, o) => {
      const t = y("survey-element");
      return i(), u("div", {
        class: a(e.row.getRowCss()),
        ref_key: "root",
        ref: n
      }, [
        (i(!0), u(_, null, D(e.row.visibleElements, (l) => (i(), g(t, {
          row: e.row,
          css: e.css,
          element: l,
          key: l.id
        }, null, 8, ["row", "css", "element"]))), 128))
      ], 2);
    };
  }
}), Xe = ["id", "role", "aria-required", "aria-invalid", "aria-labelledby", "aria-describedby", "aria-expanded", "data-name"], Ye = ["id"], Ze = {
  inheritAttrs: !1
}, xe = /* @__PURE__ */ h({
  ...Ze,
  __name: "Question",
  props: {
    survey: {},
    element: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(null), e = S(() => s.element.showErrorOnTop), o = S(() => s.element.showErrorOnBottom), t = (k) => k.cssContent, l = () => s.element.getRootStyle();
    B(() => s.element);
    const m = () => {
      n.value && s.element.afterRender(n.value);
    }, v = K(
      () => n.value,
      () => {
        m();
      }
    ), c = S(() => s.element.customWidget ? "survey-customwidget" : s.element.isDefaultRendering() ? "survey-" + s.element.getTemplate() : s.element.getComponentName()), q = S(() => s.element.survey.getQuestionContentWrapperComponentName(s.element)), f = S(() => ({
      componentData: {
        question: s.element,
        data: s.element.survey.getElementWrapperComponentData(s.element)
      }
    }));
    return O(() => {
      v();
    }), (k, L) => {
      const b = y("survey-errors"), N = y("survey-element-header"), W = y("survey-string"), V = y("survey-question-comment");
      return i(), u("div", {
        class: a(k.element.getRootCss()),
        style: I(l()),
        ref_key: "root",
        ref: n,
        onFocusin: L[0] || (L[0] = (Q) => k.element.focusIn()),
        id: k.element.id,
        role: k.element.ariaRole,
        "aria-required": k.element.ariaRequired,
        "aria-invalid": k.element.ariaInvalid,
        "aria-labelledby": k.element.ariaLabelledBy,
        "aria-describedby": k.element.ariaDescribedBy,
        "aria-expanded": k.element.ariaExpanded === null ? void 0 : k.element.ariaExpanded === "true",
        "data-name": k.element.name
      }, [
        k.element.showErrorsAboveQuestion ? (i(), g(b, {
          key: 0,
          element: k.element,
          location: "top"
        }, null, 8, ["element"])) : d("", !0),
        k.element.hasTitleOnLeftTop ? (i(), g(N, {
          key: 1,
          element: k.element,
          css: k.css
        }, null, 8, ["element", "css"])) : d("", !0),
        (i(), g(T(q.value), z(ne(f.value)), {
          default: F(() => [
            P(p("div", {
              class: a(t(k.element) || void 0),
              role: "presentation"
            }, [
              e.value ? (i(), g(b, {
                key: 0,
                element: k.element,
                location: "top"
              }, null, 8, ["element"])) : d("", !0),
              (i(), g(T(c.value), { question: k.element }, null, 8, ["question"])),
              k.element.hasComment ? (i(), u("div", {
                key: 1,
                class: a(k.element.getCommentAreaCss())
              }, [
                p("div", null, [
                  C(W, {
                    locString: k.element.locCommentText
                  }, null, 8, ["locString"])
                ]),
                C(V, { question: k.element }, null, 8, ["question"])
              ], 2)) : d("", !0),
              o.value ? (i(), g(b, {
                key: 2,
                element: k.element,
                location: "bottom"
              }, null, 8, ["element"])) : d("", !0),
              k.element.hasDescriptionUnderInput ? (i(), u("div", {
                key: 3,
                class: a(k.element.cssClasses.descriptionUnderInput),
                id: k.element.ariaDescriptionId
              }, [
                C(W, {
                  locString: k.element.locDescription
                }, null, 8, ["locString"])
              ], 10, Ye)) : d("", !0)
            ], 2), [
              [E, k.element.renderedIsExpanded]
            ])
          ]),
          _: 1
        }, 16)),
        k.element.hasTitleOnBottom ? (i(), g(N, {
          key: 2,
          element: k.element,
          css: k.css
        }, null, 8, ["element", "css"])) : d("", !0),
        k.element.showErrorsBelowQuestion ? (i(), g(b, {
          key: 3,
          element: k.element,
          location: "bottom"
        }, null, 8, ["element"])) : d("", !0)
      ], 46, Xe);
    };
  }
}), es = ["id"], ss = ["id"], ns = {
  inheritAttrs: !1
}, os = /* @__PURE__ */ h({
  ...ns,
  inheritAttrs: !1,
  __name: "Panel",
  props: {
    element: {},
    isEditMode: { type: Boolean },
    css: {}
  },
  setup(r) {
    const s = r, n = $(null), e = S(() => s.element.survey);
    return B(() => s.element), M(() => {
      s.element.survey && s.element.survey.afterRenderPanel(s.element, n.value);
    }), (o, t) => {
      const l = y("survey-errors"), m = y("survey-element-header"), v = y("survey-row"), c = y("sv-action-bar");
      return o.element.getIsContentVisible() ? (i(), u("div", {
        key: 0,
        class: a(o.element.getContainerCss()),
        id: o.element.id,
        onFocusin: t[0] || (t[0] = (q) => o.element.focusIn()),
        ref_key: "root",
        ref: n
      }, [
        o.element.showErrorsAbovePanel ? (i(), g(l, {
          key: 0,
          element: o.element
        }, null, 8, ["element"])) : d("", !0),
        o.element.hasTitle || o.element.hasDescription ? (i(), g(m, {
          key: 1,
          element: o.element,
          css: o.css
        }, null, 8, ["element", "css"])) : d("", !0),
        o.element.showErrorsAbovePanel ? d("", !0) : (i(), g(l, {
          key: 2,
          element: o.element
        }, null, 8, ["element"])),
        o.element.renderedIsExpanded ? (i(), u("div", {
          key: 3,
          id: o.element.contentId,
          style: I({ paddingLeft: o.element.innerPaddingLeft }),
          class: a(o.element.cssClasses.panel.content)
        }, [
          (i(!0), u(_, null, D(o.element.visibleRows, (q) => (i(), g(T(o.element.getSurvey().getRowWrapperComponentName(q)), z(H({
            key: q.id
          }, {
            componentData: o.element.getSurvey().getRowWrapperComponentData(q)
          })), {
            default: F(() => [
              C(v, {
                row: q,
                survey: e.value,
                css: o.css
              }, null, 8, ["row", "survey", "css"])
            ]),
            _: 2
          }, 1040))), 128)),
          C(c, {
            model: o.element.getFooterToolbar()
          }, null, 8, ["model"])
        ], 14, ss)) : d("", !0)
      ], 42, es)) : d("", !0);
    };
  }
}), ts = ["id"], is = /* @__PURE__ */ h({
  __name: "ElementHeader",
  props: {
    element: {},
    css: {}
  },
  setup(r) {
    const s = r, n = (e) => {
      typeof s.element.clickTitleFunction == "function" && s.element.clickTitleFunction(e);
    };
    return (e, o) => {
      const t = y("survey-element-title"), l = y("survey-string"), m = y("sv-action-bar");
      return i(), u("div", {
        class: a(e.element.cssHeader),
        onClick: n
      }, [
        C(t, {
          element: e.element,
          css: e.css
        }, null, 8, ["element", "css"]),
        e.element.hasDescriptionUnderTitle ? P((i(), u("div", {
          key: 0,
          class: a(e.element.cssDescription),
          id: e.element.ariaDescriptionId
        }, [
          C(l, {
            locString: e.element.locDescription
          }, null, 8, ["locString"])
        ], 10, ts)), [
          [E, e.element.hasDescription]
        ]) : d("", !0),
        e.element.hasAdditionalTitleToolbar ? (i(), g(m, {
          key: 1,
          model: e.element.additionalTitleToolbar
        }, null, 8, ["model"])) : d("", !0)
      ], 2);
    };
  }
}), rs = /* @__PURE__ */ h({
  __name: "String",
  props: {
    locString: {}
  },
  setup(r) {
    return (s, n) => (i(), g(T(s.locString.renderAs), {
      locString: s.locString.renderAsData
    }, null, 8, ["locString"]));
  }
}), ls = ["innerHTML"], as = /* @__PURE__ */ h({
  __name: "StringViewer",
  props: {
    locString: {}
  },
  setup(r) {
    const s = r, n = J(() => s.locString), e = s.locString.allowLineBreaks ? "sv-string-viewer sv-string-viewer--multiline" : "sv-string-viewer";
    return (o, t) => o.locString.hasHtml ? (i(), u("span", {
      key: 0,
      class: a(w(e)),
      innerHTML: w(n)
    }, null, 10, ls)) : (i(), u("span", {
      key: 1,
      class: a(w(e))
    }, R(w(n)), 3));
  }
}), us = ["innerHTML"], ds = /* @__PURE__ */ h({
  __name: "StringEditor",
  props: {
    locString: {}
  },
  setup(r) {
    const s = r, n = (o) => {
      const t = s.locString;
      t.text = o.target.innerText;
    }, e = (o) => {
      o.preventDefault(), o.stopPropagation();
    };
    return (o, t) => o.locString.hasHtml ? (i(), u("span", {
      key: 0,
      class: "sv-string-editor",
      contenteditable: "true",
      innerHTML: o.locString.renderedHtml,
      onBlur: n,
      onClick: e
    }, null, 40, us)) : (i(), u("span", {
      key: 1,
      class: "sv-string-editor",
      contenteditable: "true",
      onBlur: n,
      onClick: e
    }, R(o.locString.renderedHtml), 33));
  }
}), ms = ["id"], cs = /* @__PURE__ */ h({
  __name: "Skeleton",
  props: {
    element: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.element), (n, e) => (i(), u("div", {
      class: "sv-skeleton-element",
      id: n.element.id
    }, null, 8, ms));
  }
}), ps = ["id"], vs = ["value"], qs = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Text",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      const t = y("survey-text-input");
      return e.question.isReadOnlyRenderDiv() ? (i(), u("div", {
        key: 0,
        ref_key: "root",
        ref: n
      }, R(e.question.value), 513)) : e.question.dataListId ? (i(), u("div", {
        key: 1,
        ref_key: "root",
        ref: n
      }, [
        C(t, { question: e.question }, null, 8, ["question"]),
        p("datalist", {
          id: e.question.dataListId
        }, [
          (i(!0), u(_, null, D(e.question.dataList, (l) => (i(), u("option", { value: l }, null, 8, vs))), 256))
        ], 8, ps)
      ], 512)) : (i(), g(t, {
        key: 2,
        question: e.question,
        "get-ref": (l) => {
          n.value = l;
        }
      }, null, 8, ["question", "get-ref"]));
    };
  }
}), ys = ["disabled", "type", "maxlength", "min", "max", "step", "size", "id", "list", "placeholder", "autocomplete", "value", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], gs = ["disabled", "type", "maxlength", "min", "max", "step", "size", "id", "list", "placeholder", "autocomplete", "value", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], hs = /* @__PURE__ */ h({
  __name: "TextInput",
  props: {
    question: {},
    getRef: { type: Function }
  },
  setup(r, { expose: s }) {
    const n = r, e = function(l) {
      n.getRef && n.getRef(l);
    }, o = $(null);
    s({ root: o }), B(() => n.question);
    const t = S(() => n.question.inputStyle);
    return (l, m) => {
      const v = y("sv-character-counter");
      return l.question.getMaxLength() ? (i(), u("div", {
        key: 1,
        ref: (c) => e(c)
      }, [
        p("input", {
          disabled: l.question.isInputReadOnly,
          class: a(l.question.getControlClass()),
          type: l.question.inputType,
          maxlength: l.question.getMaxLength(),
          min: l.question.renderedMin,
          max: l.question.renderedMax,
          step: l.question.renderedStep,
          size: l.question.renderedInputSize,
          style: I(t.value),
          id: l.question.inputId,
          list: l.question.dataListId,
          placeholder: l.question.renderedPlaceholder,
          autocomplete: l.question.autocomplete,
          value: l.question.inputValue,
          onChange: m[6] || (m[6] = (...c) => l.question.onChange && l.question.onChange(...c)),
          onKeyup: m[7] || (m[7] = (...c) => l.question.onKeyUp && l.question.onKeyUp(...c)),
          onKeydown: m[8] || (m[8] = (...c) => l.question.onKeyDown && l.question.onKeyDown(...c)),
          onCompositionUpdate: m[9] || (m[9] = (...c) => l.question.onCompositionUpdate && l.question.onCompositionUpdate(...c)),
          onBlur: m[10] || (m[10] = (...c) => l.question.onBlur && l.question.onBlur(...c)),
          onFocus: m[11] || (m[11] = (...c) => l.question.onFocus && l.question.onFocus(...c)),
          "aria-required": l.question.a11y_input_ariaRequired,
          "aria-label": l.question.a11y_input_ariaLabel,
          "aria-labelledby": l.question.a11y_input_ariaLabelledBy,
          "aria-describedby": l.question.a11y_input_ariaDescribedBy,
          "aria-invalid": l.question.a11y_input_ariaInvalid,
          "aria-errormessage": l.question.a11y_input_ariaErrormessage
        }, null, 46, gs),
        C(v, {
          counter: l.question.characterCounter,
          remainingCharacterCounter: l.question.cssClasses.remainingCharacterCounter
        }, null, 8, ["counter", "remainingCharacterCounter"])
      ], 512)) : (i(), u("input", {
        key: 0,
        ref: (c) => e(c),
        disabled: l.question.isInputReadOnly,
        class: a(l.question.getControlClass()),
        type: l.question.inputType,
        maxlength: l.question.getMaxLength(),
        min: l.question.renderedMin,
        max: l.question.renderedMax,
        step: l.question.renderedStep,
        size: l.question.renderedInputSize,
        style: I(t.value),
        id: l.question.inputId,
        list: l.question.dataListId,
        placeholder: l.question.renderedPlaceholder,
        autocomplete: l.question.autocomplete,
        value: l.question.inputValue,
        onChange: m[0] || (m[0] = (...c) => l.question.onChange && l.question.onChange(...c)),
        onKeyup: m[1] || (m[1] = (...c) => l.question.onKeyUp && l.question.onKeyUp(...c)),
        onKeydown: m[2] || (m[2] = (...c) => l.question.onKeyDown && l.question.onKeyDown(...c)),
        onCompositionUpdate: m[3] || (m[3] = (...c) => l.question.onCompositionUpdate && l.question.onCompositionUpdate(...c)),
        onBlur: m[4] || (m[4] = (...c) => l.question.onBlur && l.question.onBlur(...c)),
        onFocus: m[5] || (m[5] = (...c) => l.question.onFocus && l.question.onFocus(...c)),
        "aria-required": l.question.a11y_input_ariaRequired,
        "aria-label": l.question.a11y_input_ariaLabel,
        "aria-labelledby": l.question.a11y_input_ariaLabelledBy,
        "aria-describedby": l.question.a11y_input_ariaDescribedBy,
        "aria-invalid": l.question.a11y_input_ariaInvalid,
        "aria-errormessage": l.question.a11y_input_ariaErrormessage
      }, null, 46, ys));
    };
  }
}), Cs = ["role", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], bs = {
  key: 0,
  class: "sv-hidden"
}, ks = { key: 7 }, fs = ["value"], ge = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "SelectBase",
  props: {
    question: {},
    showLegend: { type: Boolean }
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = (t) => s.question.getItemValueWrapperComponentName(t) || s.question.itemComponent, o = (t) => ({
      componentName: s.question.itemComponent,
      componentData: {
        question: s.question,
        item: t,
        data: s.question.getItemValueWrapperComponentData(t)
      }
    });
    return (t, l) => {
      const m = y("survey-other-choice");
      return i(), u("fieldset", {
        class: a(t.question.getSelectBaseRootCss()),
        ref_key: "root",
        ref: n,
        role: t.question.a11y_input_ariaRole,
        "aria-required": t.question.a11y_input_ariaRequired,
        "aria-label": t.question.a11y_input_ariaLabel,
        "aria-labelledby": t.question.a11y_input_ariaLabelledBy,
        "aria-describedby": t.question.a11y_input_ariaDescribedBy,
        "aria-invalid": t.question.a11y_input_ariaInvalid,
        "aria-errormessage": t.question.a11y_input_ariaErrormessage
      }, [
        t.showLegend ? (i(), u("legend", bs, R(t.question.locTitle.renderedHtml), 1)) : d("", !0),
        t.question.hasHeadItems ? (i(!0), u(_, { key: 1 }, D(t.question.headItems, (v) => (i(), g(T(e(v)), H({
          key: v.value
        }, o(v)), null, 16))), 128)) : d("", !0),
        !t.question.hasColumns && !t.question.blockedRow ? (i(!0), u(_, { key: 2 }, D(t.question.bodyItems, (v) => (i(), g(T(e(v)), H({
          key: v.value
        }, o(v)), null, 16))), 128)) : d("", !0),
        t.question.blockedRow ? (i(), u("div", {
          key: 3,
          class: a(t.question.cssClasses.rootRow)
        }, [
          !t.question.hasColumns && t.question.blockedRow ? (i(!0), u(_, { key: 0 }, D(t.question.dataChoices, (v) => (i(), g(T(e(v)), H({
            key: v.value
          }, o(v)), null, 16))), 128)) : d("", !0)
        ], 2)) : d("", !0),
        t.question.hasColumns ? (i(), u("div", {
          key: 4,
          class: a(t.question.cssClasses.rootMultiColumn)
        }, [
          t.question.hasColumns ? (i(!0), u(_, { key: 0 }, D(t.question.columns, (v, c) => (i(), u("div", {
            key: c,
            class: a(t.question.getColumnClass()),
            role: "presentation"
          }, [
            (i(!0), u(_, null, D(v, (q) => (i(), g(T(e(q)), H({
              key: q.value
            }, o(q)), null, 16))), 128))
          ], 2))), 128)) : d("", !0)
        ], 2)) : d("", !0),
        t.question.hasFootItems ? (i(!0), u(_, { key: 5 }, D(t.question.footItems, (v) => (i(), g(T(e(v)), H({
          key: v.value
        }, o(v)), null, 16))), 128)) : d("", !0),
        t.question.renderedValue && t.question.isOtherSelected ? (i(), g(m, {
          key: 6,
          question: t.question
        }, null, 8, ["question"])) : d("", !0),
        t.question.showClearButtonInContent ? (i(), u("div", ks, [
          p("input", {
            type: "button",
            class: a(t.question.cssClasses.clearButton),
            onClick: l[0] || (l[0] = () => {
              t.question.clearValue();
            }),
            value: t.question.clearButtonCaption
          }, null, 10, fs)
        ])) : d("", !0)
      ], 10, Cs);
    };
  }
}), ws = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Checkbox",
  props: {
    question: {}
  },
  setup(r) {
    return (s, n) => (i(), g(ge, {
      question: s.question,
      "show-legend": !0
    }, null, 8, ["question"]));
  }
}), Is = ["name", "checked", "value", "id", "disabled"], Ss = ["xlink:href"], Rs = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "CheckboxItem",
  props: {
    question: {},
    item: {},
    hideLabel: { type: Boolean }
  },
  setup(r) {
    const s = r;
    B(() => s.item);
    const n = (e) => {
      s.question.clickItemHandler(s.item, e.target.checked);
    };
    return (e, o) => {
      const t = y("survey-string");
      return i(), u("div", {
        role: "presentation",
        class: a(e.question.getItemClass(e.item))
      }, [
        p("label", {
          class: a(e.question.getLabelClass(e.item))
        }, [
          p("input", {
            type: "checkbox",
            role: "option",
            name: e.question.name + e.item.id,
            checked: e.question.isItemSelected(e.item),
            onInput: o[0] || (o[0] = (l) => {
              n(l);
            }),
            value: e.item.value,
            id: e.question.getItemId(e.item),
            disabled: !e.question.getItemEnabled(e.item),
            class: a(e.question.cssClasses.itemControl)
          }, null, 42, Is),
          e.question.cssClasses.materialDecorator ? (i(), u("span", {
            key: 0,
            class: a(e.question.cssClasses.materialDecorator)
          }, [
            e.question.itemSvgIcon ? (i(), u("svg", {
              key: 0,
              class: a(e.question.cssClasses.itemDecorator)
            }, [
              p("use", {
                "xlink:href": e.question.itemSvgIcon
              }, null, 8, Ss)
            ], 2)) : d("", !0)
          ], 2)) : d("", !0),
          e.hideLabel ? d("", !0) : (i(), u("span", {
            key: 1,
            class: a(e.question.cssClasses.controlLabel)
          }, [
            C(t, {
              locString: e.item.locText
            }, null, 8, ["locString"])
          ], 2))
        ], 2)
      ], 2);
    };
  }
}), Ts = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Radiogroup",
  props: {
    question: {}
  },
  setup(r) {
    return (s, n) => (i(), g(ge, { question: s.question }, null, 8, ["question"]));
  }
}), $s = ["name", "value", "id", "aria-errormessage", "disabled"], _s = ["xlink:href"], Ds = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "RadiogroupItem",
  props: {
    question: {},
    item: {},
    hideLabel: { type: Boolean }
  },
  setup(r) {
    const s = r, n = (t) => s.question.getLabelClass(t), e = (t) => s.question.getControlLabelClass(t), o = S({
      get: () => s.question.renderedValue,
      set: (t) => {
        const l = s.question;
        l.renderedValue = t;
      }
    });
    return B(() => s.item), (t, l) => {
      const m = y("survey-string");
      return i(), u("div", {
        role: "presentation",
        class: a(t.question.getItemClass(t.item))
      }, [
        p("label", {
          onMousedown: l[1] || (l[1] = (v) => t.question.onMouseDown()),
          class: a(n(t.item))
        }, [
          P(p("input", {
            type: "radio",
            name: t.question.questionName,
            value: t.item.value,
            id: t.question.getItemId(t.item),
            "aria-errormessage": t.question.ariaErrormessage,
            "onUpdate:modelValue": l[0] || (l[0] = (v) => o.value = v),
            disabled: !t.question.getItemEnabled(t.item),
            class: a(t.question.cssClasses.itemControl)
          }, null, 10, $s), [
            [x, o.value]
          ]),
          t.question.cssClasses.materialDecorator ? (i(), u("span", {
            key: 0,
            class: a(t.question.cssClasses.materialDecorator)
          }, [
            t.question.itemSvgIcon ? (i(), u("svg", {
              key: 0,
              class: a(t.question.cssClasses.itemDecorator)
            }, [
              p("use", {
                "xlink:href": t.question.itemSvgIcon
              }, null, 8, _s)
            ], 2)) : d("", !0)
          ], 2)) : d("", !0),
          t.hideLabel ? d("", !0) : (i(), u("span", {
            key: 1,
            class: a(e(t.item))
          }, [
            C(m, {
              locString: t.item.locText
            }, null, 8, ["locString"])
          ], 2))
        ], 34)
      ], 2);
    };
  }
}), Bs = ["src"], Ls = ["title"], Ns = { key: 0 }, Ps = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Signaturepad",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      const t = y("survey-string"), l = y("sv-svg-icon"), m = y("sv-loading-indicator");
      return i(), u("div", {
        class: a(e.question.cssClasses.root),
        ref_key: "root",
        ref: n,
        style: I({
          width: e.question.renderedCanvasWidth
        })
      }, [
        P(p("div", {
          class: a(e.question.cssClasses.placeholder)
        }, [
          C(t, {
            locString: e.question.locRenderedPlaceholder
          }, null, 8, ["locString"])
        ], 2), [
          [E, e.question.needShowPlaceholder()]
        ]),
        p("div", null, [
          e.question.backgroundImage ? (i(), u("img", {
            key: 0,
            class: a(e.question.cssClasses.backgroundImage),
            src: e.question.backgroundImage,
            style: I({
              width: e.question.renderedCanvasWidth
            })
          }, null, 14, Bs)) : d("", !0),
          p("canvas", {
            tabindex: "-1",
            class: a(e.question.cssClasses.canvas),
            onBlur: o[0] || (o[0] = (...v) => e.question.onBlur && e.question.onBlur(...v))
          }, null, 34)
        ]),
        e.question.canShowClearButton ? (i(), u("div", {
          key: 0,
          class: a(e.question.cssClasses.controls)
        }, [
          p("button", {
            type: "button",
            class: a(e.question.cssClasses.clearButton),
            title: e.question.clearButtonCaption,
            onClick: o[1] || (o[1] = () => {
              e.question.clearValue();
            })
          }, [
            e.question.cssClasses.clearButtonIconId ? d("", !0) : (i(), u("span", Ns, "\u2716")),
            e.question.cssClasses.clearButtonIconId ? (i(), g(l, {
              key: 1,
              iconName: e.question.cssClasses.clearButtonIconId,
              size: "auto"
            }, null, 8, ["iconName"])) : d("", !0)
          ], 10, Ls)
        ], 2)) : d("", !0),
        e.question.showLoadingIndicator ? (i(), u("div", {
          key: 1,
          class: a(e.question.cssClasses.loadingIndicator)
        }, [
          C(m)
        ], 2)) : d("", !0)
      ], 6);
    };
  }
}), As = ["innerHTML"], Ms = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Html",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = J(() => s.question.locHtml);
    return (o, t) => (i(), u("div", {
      ref_key: "root",
      ref: n,
      class: a(o.question.renderCssRoot),
      innerHTML: w(e)
    }, null, 10, As));
  }
}), Es = ["src", "alt", "width", "height"], Hs = ["src", "width", "height"], Ws = ["src", "width", "height"], Vs = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Image",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = J(() => s.question.locImageLink);
    return (o, t) => {
      const l = y("sv-svg-icon");
      return i(), u("div", {
        class: a(o.question.cssClasses.root),
        ref_key: "root",
        ref: n
      }, [
        o.question.renderedMode === "image" ? P((i(), u("img", {
          key: 0,
          class: a(o.question.getImageCss()),
          src: w(e),
          alt: o.question.altText || o.question.title,
          width: o.question.renderedWidth,
          height: o.question.renderedHeight,
          style: I({
            objectFit: o.question.imageFit,
            width: o.question.renderedStyleWidth,
            height: o.question.renderedStyleHeight
          }),
          onLoad: t[0] || (t[0] = (m) => {
            o.question.onLoadHandler();
          }),
          onError: t[1] || (t[1] = (m) => {
            o.question.onErrorHandler();
          })
        }, null, 46, Es)), [
          [E, w(e) && !o.question.contentNotLoaded]
        ]) : d("", !0),
        o.question.renderedMode === "video" ? P((i(), u("video", {
          key: 1,
          controls: "",
          class: a(o.question.getImageCss()),
          src: w(e),
          width: o.question.renderedWidth,
          height: o.question.renderedHeight,
          style: I({
            objectFit: o.question.imageFit,
            width: o.question.renderedStyleWidth,
            height: o.question.renderedStyleHeight
          }),
          onLoadedmetadata: t[2] || (t[2] = (m) => {
            o.question.onLoadHandler();
          }),
          onError: t[3] || (t[3] = (m) => {
            o.question.onErrorHandler();
          })
        }, null, 46, Hs)), [
          [E, w(e) && !o.question.contentNotLoaded]
        ]) : d("", !0),
        o.question.renderedMode === "youtube" ? (i(), u("iframe", {
          key: 2,
          class: a(o.question.getImageCss()),
          src: w(e),
          width: o.question.renderedWidth,
          height: o.question.renderedHeight,
          style: I({
            objectFit: o.question.imageFit,
            width: o.question.renderedStyleWidth,
            height: o.question.renderedStyleHeight
          })
        }, null, 14, Ws)) : d("", !0),
        !w(e) || o.question.contentNotLoaded ? (i(), u("div", {
          key: 3,
          class: a(o.question.cssClasses.noImage)
        }, [
          C(l, {
            iconName: o.question.cssClasses.noImageSvgIconId,
            size: 48
          }, null, 8, ["iconName"])
        ], 2)) : d("", !0)
      ], 2);
    };
  }
}), Fs = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Expression",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => (i(), u("div", {
      class: a(e.question.cssClasses.root),
      ref_key: "root",
      ref: n
    }, R(e.question.formatedValue), 3));
  }
}), Os = ["id", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "multiple", "title", "accept", "capture"], zs = ["id", "multiple", "placeholder"], Us = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "File",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      const t = y("survey-string"), l = y("sv-file-choose-btn"), m = y("sv-action-bar"), v = y("sv-file-clean-btn"), c = y("sv-loading-indicator"), q = y("sv-file-video"), f = y("sv-file-preview");
      return i(), u("div", {
        class: a(e.question.fileRootCss),
        ref_key: "root",
        ref: n
      }, [
        !e.question.isReadOnly && e.question.hasFileUI ? (i(), u("input", {
          key: 0,
          class: a(e.question.cssClasses.fileInput),
          tabindex: "-1",
          type: "file",
          id: e.question.inputId,
          "aria-required": e.question.ariaRequired,
          "aria-label": e.question.ariaLabel,
          "aria-invalid": e.question.ariaInvalid,
          "aria-errormessage": e.question.ariaErrormessage,
          multiple: e.question.allowMultiple,
          title: e.question.inputTitle,
          accept: e.question.acceptedTypes,
          capture: e.question.renderCapture
        }, null, 10, Os)) : d("", !0),
        e.question.isReadOnly ? (i(), u("input", {
          key: 1,
          type: "file",
          disabled: "",
          id: e.question.inputId,
          class: a(e.question.getReadOnlyFileCss()),
          multiple: e.question.allowMultiple,
          placeholder: e.question.title,
          style: { color: "transparent" }
        }, null, 10, zs)) : d("", !0),
        p("div", {
          class: a(e.question.cssClasses.dragArea),
          onDrop: o[0] || (o[0] = (...k) => e.question.onDrop && e.question.onDrop(...k)),
          onDragover: o[1] || (o[1] = (...k) => e.question.onDragOver && e.question.onDragOver(...k)),
          onDragleave: o[2] || (o[2] = (...k) => e.question.onDragLeave && e.question.onDragLeave(...k)),
          onDragenter: o[3] || (o[3] = (...k) => e.question.onDragEnter && e.question.onDragEnter(...k))
        }, [
          e.question.showFileDecorator ? (i(), u("div", {
            key: 0,
            class: a(e.question.getFileDecoratorCss())
          }, [
            p("span", {
              class: a(e.question.cssClasses.dragAreaPlaceholder)
            }, [
              C(t, {
                locString: e.question.locRenderedPlaceholder
              }, null, 8, ["locString"])
            ], 2),
            p("div", {
              class: a(e.question.cssClasses.wrapper)
            }, [
              e.question.showChooseButton ? (i(), g(l, {
                key: 0,
                data: { question: e.question }
              }, null, 8, ["data"])) : d("", !0),
              e.question.actionsContainerVisible ? (i(), g(m, {
                key: 1,
                model: e.question.actionsContainer
              }, null, 8, ["model"])) : d("", !0),
              e.question.isEmpty() ? (i(), u("span", {
                key: 2,
                class: a(e.question.cssClasses.noFileChosen)
              }, R(e.question.noFileChosenCaption), 3)) : d("", !0)
            ], 2)
          ], 2)) : d("", !0),
          e.question.showRemoveButton ? (i(), g(v, {
            key: 1,
            question: e.question,
            css: e.question.showRemoveButton
          }, null, 8, ["question", "css"])) : d("", !0),
          e.question.showLoadingIndicator ? (i(), u("div", {
            key: 2,
            class: a(e.question.cssClasses.loadingIndicator)
          }, [
            C(c)
          ], 2)) : d("", !0),
          e.question.isPlayingVideo ? (i(), g(q, {
            key: 3,
            question: e.question
          }, null, 8, ["question"])) : d("", !0),
          e.question.allowShowPreview ? (i(), g(f, {
            key: 4,
            question: e.question
          }, null, 8, ["question"])) : d("", !0),
          e.question.showRemoveButtonBottom ? (i(), g(v, {
            key: 5,
            question: e.question,
            css: e.question.showRemoveButtonBottom
          }, null, 8, ["question", "css"])) : d("", !0),
          e.question.fileNavigatorVisible ? (i(), g(m, {
            key: 6,
            model: e.question.fileNavigator
          }, null, 8, ["model"])) : d("", !0)
        ], 34)
      ], 2);
    };
  }
}), Ks = { class: "sv-hidden" }, ce = "survey-imagepicker-item", Qs = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Imagepicker",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = (t) => s.question.getItemValueWrapperComponentName(t) || ce, o = (t) => ({
      componentName: ce,
      componentData: {
        question: s.question,
        item: t,
        data: s.question.getItemValueWrapperComponentData(t)
      }
    });
    return (t, l) => (i(), u("fieldset", {
      class: a(t.question.getSelectBaseRootCss()),
      ref_key: "root",
      ref: n
    }, [
      p("legend", Ks, R(t.question.locTitle.renderedHtml), 1),
      t.question.hasColumns ? d("", !0) : (i(!0), u(_, { key: 0 }, D(t.question.visibleChoices, (m) => (i(), g(T(e(m)), H({
        key: m.value
      }, o(m)), null, 16))), 128)),
      t.question.hasColumns ? (i(!0), u(_, { key: 1 }, D(t.question.columns, (m, v) => (i(), u("div", {
        class: a(t.question.getColumnClass()),
        key: v,
        role: "presentation"
      }, [
        (i(!0), u(_, null, D(m, (c) => (i(), g(T(e(c)), H({
          key: c.value
        }, o(c)), null, 16))), 128))
      ], 2))), 128)) : d("", !0)
    ], 2));
  }
}), js = ["name", "value", "id", "disabled", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Gs = ["name", "value", "id", "disabled", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Js = ["src", "width", "height", "alt"], Xs = ["src", "width", "height"], Ys = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "ImagepickerItem",
  props: {
    question: {},
    item: {}
  },
  setup(r) {
    const s = r, n = (o) => s.question.getItemClass(o);
    B(() => s.item);
    const e = J(() => s.item.locImageLink);
    return (o, t) => {
      const l = y("sv-svg-icon"), m = y("survey-string");
      return i(), u("div", {
        class: a(n(o.item))
      }, [
        p("label", {
          class: a(o.question.cssClasses.label)
        }, [
          o.question.multiSelect ? P((i(), u("input", {
            key: 0,
            type: "checkbox",
            name: o.question.questionName,
            value: o.item.value,
            id: o.question.getItemId(o.item),
            "onUpdate:modelValue": t[0] || (t[0] = (v) => o.question.value = v),
            disabled: !o.question.getItemEnabled(o.item),
            "aria-required": o.question.ariaRequired,
            "aria-label": o.question.ariaLabel,
            "aria-invalid": o.question.ariaInvalid,
            "aria-errormessage": o.question.ariaErrormessage,
            class: a(o.question.cssClasses.itemControl)
          }, null, 10, js)), [
            [oe, o.question.value]
          ]) : P((i(), u("input", {
            key: 1,
            type: "radio",
            name: o.question.questionName,
            value: o.item.value,
            id: o.question.getItemId(o.item),
            "onUpdate:modelValue": t[1] || (t[1] = (v) => o.question.value = v),
            disabled: !o.question.getItemEnabled(o.item),
            "aria-required": o.question.ariaRequired,
            "aria-label": o.question.ariaLabel,
            "aria-invalid": o.question.ariaInvalid,
            "aria-errormessage": o.question.ariaErrormessage,
            class: a(o.question.cssClasses.itemControl)
          }, null, 10, Gs)), [
            [x, o.question.value]
          ]),
          p("div", {
            class: a(o.question.cssClasses.itemDecorator)
          }, [
            p("div", {
              class: a(o.question.cssClasses.imageContainer)
            }, [
              o.question.cssClasses.checkedItemDecorator ? (i(), u("span", {
                key: 0,
                class: a(o.question.cssClasses.checkedItemDecorator)
              }, [
                o.question.cssClasses.checkedItemSvgIconId ? (i(), g(l, {
                  key: 0,
                  class: a(o.question.cssClasses.checkedItemSvgIcon),
                  size: "auto",
                  iconName: o.question.cssClasses.checkedItemSvgIconId
                }, null, 8, ["class", "iconName"])) : d("", !0)
              ], 2)) : d("", !0),
              w(e) && !o.item.contentNotLoaded && o.question.contentMode === "image" ? (i(), u("img", {
                key: 1,
                class: a(o.question.cssClasses.image),
                src: w(e),
                width: o.question.renderedImageWidth,
                height: o.question.renderedImageHeight,
                style: I({ objectFit: o.question.imageFit }),
                alt: o.item.locText.renderedHtml,
                onLoad: t[2] || (t[2] = (v) => {
                  o.question.onContentLoaded(o.item, v);
                }),
                onError: t[3] || (t[3] = (v) => {
                  o.item.onErrorHandler();
                })
              }, null, 46, Js)) : d("", !0),
              w(e) && !o.item.contentNotLoaded && o.question.contentMode === "video" ? (i(), u("video", {
                key: 2,
                controls: "",
                class: a(o.question.cssClasses.image),
                src: w(e),
                width: o.question.renderedImageWidth,
                height: o.question.renderedImageHeight,
                style: I({ objectFit: o.question.imageFit }),
                onLoadedmetadata: t[4] || (t[4] = (v) => {
                  o.question.onContentLoaded(o.item, v);
                }),
                onError: t[5] || (t[5] = (v) => {
                  o.item.onErrorHandler();
                })
              }, null, 46, Xs)) : d("", !0),
              !w(e) || o.item.contentNotLoaded ? (i(), u("div", {
                key: 3,
                class: a(o.question.cssClasses.itemNoImage),
                style: I({
                  width: o.question.renderedImageWidth + "px",
                  height: o.question.renderedImageHeight + "px",
                  objectFit: o.question.imageFit
                })
              }, [
                C(l, {
                  class: a(o.question.cssClasses.itemNoImageSvgIcon),
                  iconName: o.question.cssClasses.itemNoImageSvgIconId,
                  size: 48
                }, null, 8, ["class", "iconName"])
              ], 6)) : d("", !0)
            ], 2),
            o.question.showLabel ? (i(), u("span", {
              key: 0,
              class: a(o.question.cssClasses.itemText)
            }, [
              C(m, {
                locString: o.item.locText
              }, null, 8, ["locString"])
            ], 2)) : d("", !0)
          ], 2)
        ], 2)
      ], 2);
    };
  }
}), Zs = ["readonly", "disabled", "value", "id", "maxlength", "cols", "rows", "placeholder", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], xs = ["readonly", "disabled", "value", "id", "maxlength", "cols", "rows", "placeholder", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], en = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Comment",
  props: {
    question: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = (o) => {
      const t = s.question;
      t.value = o.target.value;
    };
    return (o, t) => {
      const l = y("sv-character-counter");
      return !o.question.isReadOnlyRenderDiv() && !o.question.getMaxLength() ? (i(), u("textarea", {
        key: 0,
        ref_key: "root",
        ref: n,
        readonly: o.question.isInputReadOnly,
        disabled: o.question.isInputReadOnly,
        value: o.question.value,
        id: o.question.inputId,
        maxlength: o.question.getMaxLength(),
        cols: o.question.cols,
        rows: o.question.rows,
        placeholder: o.question.renderedPlaceholder,
        class: a(o.question.className),
        onChange: e,
        onInput: t[0] || (t[0] = (m) => {
          o.question.onInput(m);
        }),
        onKeydown: t[1] || (t[1] = (m) => {
          o.question.onKeyDown(m);
        }),
        "aria-required": o.question.a11y_input_ariaRequired,
        "aria-label": o.question.a11y_input_ariaLabel,
        "aria-labelledby": o.question.a11y_input_ariaLabelledBy,
        "aria-describedby": o.question.a11y_input_ariaDescribedBy,
        "aria-invalid": o.question.a11y_input_ariaInvalid,
        "aria-errormessage": o.question.a11y_input_ariaErrormessage,
        style: I({ resize: o.question.resizeStyle })
      }, null, 46, Zs)) : !o.question.isReadOnlyRenderDiv() && o.question.getMaxLength() ? (i(), u("div", {
        key: 1,
        ref_key: "root",
        ref: n
      }, [
        p("textarea", {
          readonly: o.question.isInputReadOnly,
          disabled: o.question.isInputReadOnly,
          value: o.question.value,
          id: o.question.inputId,
          maxlength: o.question.getMaxLength(),
          cols: o.question.cols,
          rows: o.question.rows,
          placeholder: o.question.renderedPlaceholder,
          class: a(o.question.className),
          onChange: e,
          onInput: t[2] || (t[2] = (m) => {
            o.question.onInput(m);
          }),
          onKeydown: t[3] || (t[3] = (m) => {
            o.question.onKeyDown(m);
          }),
          "aria-required": o.question.a11y_input_ariaRequired,
          "aria-label": o.question.a11y_input_ariaLabel,
          "aria-labelledby": o.question.a11y_input_ariaLabelledBy,
          "aria-describedby": o.question.a11y_input_ariaDescribedBy,
          "aria-invalid": o.question.a11y_input_ariaInvalid,
          "aria-errormessage": o.question.a11y_input_ariaErrormessage,
          style: I({ resize: o.question.resizeStyle })
        }, null, 46, xs),
        C(l, {
          counter: o.question.characterCounter,
          remainingCharacterCounter: o.question.cssClasses.remainingCharacterCounter
        }, null, 8, ["counter", "remainingCharacterCounter"])
      ], 512)) : (i(), u("div", {
        key: 2,
        ref_key: "root",
        ref: n
      }, R(o.question.value), 513));
    };
  }
}), sn = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Dropdown",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      const t = y("sv-dropdown"), l = y("survey-other-choice");
      return i(), u("div", {
        class: a(e.question.renderCssRoot),
        ref_key: "root",
        ref: n
      }, [
        C(t, { question: e.question }, null, 8, ["question"]),
        e.question.isOtherSelected ? (i(), g(l, {
          key: 0,
          question: e.question
        }, null, 8, ["question"])) : d("", !0)
      ], 2);
    };
  }
}), nn = ["id", "autocomplete", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "required"], on = {
  key: 0,
  value: ""
}, tn = ["id"];
ee.Instance.registerRenderer(
  "dropdown",
  "select",
  "sv-dropdown-select"
);
const rn = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "DropdownSelect",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = (l) => {
      s.question.onClick(l);
    }, o = (l) => {
      s.question.onKeyUp(l);
    }, t = S({
      get() {
        var l;
        return (l = s.question.value) != null ? l : "";
      },
      set(l) {
        const m = s.question;
        l === "" ? m.renderedValue = void 0 : m.renderedValue = l;
      }
    });
    return (l, m) => {
      const v = y("sv-dropdown-option-item"), c = y("sv-svg-icon"), q = y("survey-other-choice");
      return i(), u("div", {
        class: a(l.question.renderCssRoot),
        ref_key: "root",
        ref: n
      }, [
        p("div", {
          class: a(l.question.cssClasses.selectWrapper)
        }, [
          l.question.isReadOnly ? (i(), u("div", {
            key: 1,
            disabled: "",
            id: l.question.inputId,
            class: a(l.question.getControlClass())
          }, R(l.question.readOnlyText), 11, tn)) : P((i(), u("select", {
            key: 0,
            id: l.question.inputId,
            "onUpdate:modelValue": m[0] || (m[0] = (f) => t.value = f),
            onClick: e,
            onKeyup: o,
            autocomplete: l.question.autocomplete,
            class: a(l.question.getControlClass()),
            "aria-required": l.question.ariaRequired,
            "aria-label": l.question.ariaLabel,
            "aria-invalid": l.question.ariaInvalid,
            "aria-errormessage": l.question.ariaErrormessage,
            required: l.question.isRequired
          }, [
            l.question.allowClear ? (i(), u("option", on, R(l.question.placeholder), 1)) : d("", !0),
            (i(!0), u(_, null, D(l.question.visibleChoices, (f) => (i(), g(v, {
              item: f,
              key: f.id
            }, null, 8, ["item"]))), 128))
          ], 42, nn)), [
            [fe, t.value]
          ]),
          l.question.cssClasses.chevronButtonIconId ? (i(), u("div", {
            key: 2,
            class: a(l.question.cssClasses.chevronButton)
          }, [
            C(c, {
              class: a(l.question.cssClasses.chevronButtonSvg),
              iconName: l.question.cssClasses.chevronButtonIconId,
              size: "auto"
            }, null, 8, ["class", "iconName"])
          ], 2)) : d("", !0)
        ], 2),
        l.question.isOtherSelected ? (i(), g(q, {
          key: 0,
          question: l.question
        }, null, 8, ["question"])) : d("", !0)
      ], 2);
    };
  }
}), ln = ["value", "disabled"], an = /* @__PURE__ */ h({
  __name: "OptionItem",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, n = J(() => s.item.locText);
    return B(() => s.item), (e, o) => (i(), u("option", {
      value: e.item.value,
      disabled: !e.item.isEnabled
    }, R(w(n)), 9, ln));
  }
}), un = ["id", "disabled", "tabindex", "role", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "aria-expanded", "aria-controls", "aria-activedescendant", "required"], dn = { style: { visibility: "hidden" } }, mn = ["disabled", "inputmode", "role", "id", "tabindex", "readonly", "aria-expanded", "aria-controls", "aria-label", "aria-labelledby", "aria-describedby", "aria-activedescendant", "placeholder"], cn = ["id"], pn = /* @__PURE__ */ h({
  __name: "Dropdown",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null), e = S(() => {
      const b = s.question;
      return b.dropdownListModel || (b.dropdownListModel = new De(b)), s.question.dropdownListModel;
    }), o = (b) => {
      var N;
      (N = e.value) == null || N.onClick(b);
    }, t = (b) => {
      var N;
      (N = e.value) == null || N.chevronPointerDown(b);
    }, l = (b) => {
      var N;
      (N = e.value) == null || N.onClear(b);
    }, m = (b) => {
      var N;
      (N = e.value) == null || N.keyHandler(b);
    }, v = () => {
      if (n.value) {
        const b = n.value, N = e.value.inputStringRendered;
        Be.isTwoValueEquals(N, b.value, !1, !0, !1) || (b.value = e.value.inputStringRendered);
      }
    }, c = (b) => {
      var N;
      (N = e.value) == null || N.onBlur(b), v();
    }, q = (b) => {
      var N;
      (N = e.value) == null || N.onFocus(b);
    }, f = (b) => {
      e.value.inputStringRendered = b.target.value;
    }, k = S(
      () => s.question.showSelectedItemLocText
    ), L = S(() => s.question.selectedItemLocText);
    return B(() => e.value), te(v), M(v), (b, N) => {
      const W = y("survey-string"), V = y("sv-svg-icon"), Q = y("sv-popup");
      return i(), u("div", {
        class: a(b.question.cssClasses.selectWrapper),
        onClick: o
      }, [
        b.question.isReadOnly ? d("", !0) : (i(), u("div", {
          key: 0,
          id: b.question.inputId,
          disabled: b.question.isInputReadOnly ? !0 : null,
          tabindex: e.value.noTabIndex ? void 0 : 0,
          onKeydown: m,
          onBlur: c,
          class: a(b.question.getControlClass()),
          role: b.question.ariaRole,
          "aria-required": b.question.ariaRequired,
          "aria-label": b.question.ariaLabel,
          "aria-invalid": b.question.ariaInvalid,
          "aria-errormessage": b.question.ariaErrormessage,
          "aria-expanded": b.question.ariaExpanded === null ? void 0 : b.question.ariaExpanded === "true",
          "aria-controls": e.value.listElementId,
          "aria-activedescendant": e.value.ariaActivedescendant,
          required: b.question.isRequired ? !0 : null
        }, [
          e.value.showHintPrefix ? (i(), u("div", {
            key: 0,
            class: a(b.question.cssClasses.hintPrefix)
          }, [
            p("span", null, R(e.value.hintStringPrefix), 1)
          ], 2)) : d("", !0),
          p("div", {
            class: a(b.question.cssClasses.controlValue)
          }, [
            k.value ? (i(), g(W, {
              key: 0,
              locString: L.value
            }, null, 8, ["locString"])) : d("", !0),
            e.value.showHintString ? (i(), u("div", {
              key: 1,
              class: a(b.question.cssClasses.hintSuffix)
            }, [
              p("span", dn, R(e.value.inputStringRendered), 1),
              p("span", null, R(e.value.hintStringSuffix), 1)
            ], 2)) : d("", !0),
            b.question.showInputFieldComponent ? (i(), g(T(b.question.inputFieldComponentName), {
              key: 2,
              item: e.value.getSelectedAction(),
              question: b.question
            }, null, 8, ["item", "question"])) : d("", !0),
            p("input", {
              type: "text",
              ref_key: "inputElement",
              ref: n,
              class: a(b.question.cssClasses.filterStringInput),
              disabled: b.question.isInputReadOnly,
              autocomplete: "off",
              inputmode: e.value.inputMode,
              role: e.value.filterStringEnabled ? b.question.ariaRole : void 0,
              id: b.question.getInputId(),
              tabindex: e.value.noTabIndex ? void 0 : -1,
              readonly: e.value.filterReadOnly ? !0 : void 0,
              "aria-expanded": b.question.ariaExpanded === null ? void 0 : b.question.ariaExpanded === "true",
              "aria-controls": e.value.listElementId,
              "aria-label": b.question.a11y_input_ariaLabel,
              "aria-labelledby": b.question.a11y_input_ariaLabelledBy,
              "aria-describedby": b.question.a11y_input_ariaDescribedBy,
              "aria-activedescendant": e.value.ariaActivedescendant,
              placeholder: e.value.placeholderRendered,
              onInput: f,
              onBlur: c,
              onFocus: q
            }, null, 42, mn)
          ], 2),
          b.question.allowClear && b.question.cssClasses.cleanButtonIconId ? P((i(), u("div", {
            key: 1,
            class: a(b.question.cssClasses.cleanButton),
            onClick: l,
            "aria-hidden": "true"
          }, [
            C(V, {
              class: a(b.question.cssClasses.cleanButtonSvg),
              iconName: b.question.cssClasses.cleanButtonIconId,
              title: b.question.clearCaption,
              size: "auto"
            }, null, 8, ["class", "iconName", "title"])
          ], 2)), [
            [E, b.question.showClearButton]
          ]) : d("", !0)
        ], 42, un)),
        b.question.isReadOnly ? (i(), u("div", {
          key: 2,
          disabled: "",
          id: b.question.inputId,
          class: a(b.question.getControlClass())
        }, [
          b.question.selectedItemLocText ? (i(), g(W, {
            key: 0,
            locString: b.question.selectedItemLocText
          }, null, 8, ["locString"])) : d("", !0),
          p("div", null, R(b.question.readOnlyText), 1)
        ], 10, cn)) : (i(), g(Q, {
          key: 1,
          model: b.question.dropdownListModel.popupModel
        }, null, 8, ["model"])),
        b.question.cssClasses.chevronButtonIconId ? (i(), u("div", {
          key: 3,
          class: a(b.question.cssClasses.chevronButton),
          onPointerdown: t,
          "aria-hidden": "true"
        }, [
          C(V, {
            class: a(b.question.cssClasses.chevronButtonSvg),
            iconName: b.question.cssClasses.chevronButtonIconId,
            size: "auto"
          }, null, 8, ["class", "iconName"])
        ], 34)) : d("", !0)
      ], 2);
    };
  }
}), vn = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Tagbox",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      const t = y("sv-tagbox"), l = y("survey-other-choice");
      return i(), u("div", {
        class: a(e.question.renderCssRoot),
        ref_key: "root",
        ref: n
      }, [
        C(t, { question: e.question }, null, 8, ["question"]),
        e.question.isOtherSelected ? (i(), g(l, {
          key: 0,
          question: e.question
        }, null, 8, ["question"])) : d("", !0)
      ], 2);
    };
  }
}), qn = ["id", "tabindex", "disabled", "role", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "aria-expanded", "aria-controls", "aria-activedescendant", "required"], yn = ["id"], gn = /* @__PURE__ */ h({
  __name: "Tagbox",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = S(() => {
      const c = s.question;
      return c.dropdownListModel || (c.dropdownListModel = new Le(c)), s.question.dropdownListModel;
    }), e = (c) => {
      var q;
      (q = n.value) == null || q.onClick(c);
    }, o = (c) => {
      var q;
      (q = n.value) == null || q.chevronPointerDown(c);
    }, t = (c) => {
      var q;
      (q = n.value) == null || q.onClear(c);
    }, l = (c) => {
      var q;
      (q = n.value) == null || q.keyHandler(c);
    }, m = (c) => {
      var q;
      (q = n.value) == null || q.onBlur(c);
    }, v = le(() => s.question.selectedChoices);
    return B(() => n.value), (c, q) => {
      const f = y("sv-tagbox-item"), k = y("sv-tagbox-filter"), L = y("sv-svg-icon"), b = y("sv-popup"), N = y("survey-string");
      return i(), u("div", {
        class: a(c.question.cssClasses.selectWrapper),
        onClick: e
      }, [
        c.question.isReadOnly ? d("", !0) : (i(), u("div", {
          key: 0,
          id: c.question.inputId,
          tabindex: n.value.noTabIndex ? void 0 : 0,
          disabled: c.question.isInputReadOnly ? !0 : null,
          onKeydown: l,
          onBlur: m,
          class: a(c.question.getControlClass()),
          role: c.question.ariaRole,
          "aria-required": c.question.ariaRequired,
          "aria-label": c.question.ariaLabel,
          "aria-invalid": c.question.ariaInvalid,
          "aria-errormessage": c.question.ariaErrormessage,
          "aria-expanded": c.question.ariaExpanded === null ? void 0 : c.question.ariaExpanded === "true",
          "aria-controls": n.value.listElementId,
          "aria-activedescendant": n.value.ariaActivedescendant,
          required: c.question.isRequired ? !0 : null
        }, [
          p("div", {
            class: a(c.question.cssClasses.controlValue)
          }, [
            (i(!0), u(_, null, D(w(v), (W, V) => (i(), g(f, {
              item: W,
              question: c.question,
              key: "item" + V
            }, null, 8, ["item", "question"]))), 128)),
            C(k, {
              model: n.value,
              question: c.question
            }, null, 8, ["model", "question"])
          ], 2),
          c.question.allowClear && c.question.cssClasses.cleanButtonIconId ? P((i(), u("div", {
            key: 0,
            class: a(c.question.cssClasses.cleanButton),
            onClick: t,
            "aria-hidden": "true"
          }, [
            C(L, {
              class: a(c.question.cssClasses.cleanButtonSvg),
              iconName: c.question.cssClasses.cleanButtonIconId,
              title: c.question.clearCaption,
              size: "auto"
            }, null, 8, ["class", "iconName", "title"])
          ], 2)), [
            [E, c.question.showClearButton]
          ]) : d("", !0)
        ], 42, qn)),
        c.question.isReadOnly ? (i(), u("div", {
          key: 2,
          disabled: "",
          id: c.question.inputId,
          class: a(c.question.getControlClass())
        }, [
          c.question.locReadOnlyText ? (i(), g(N, {
            key: 0,
            locString: c.question.locReadOnlyText
          }, null, 8, ["locString"])) : d("", !0)
        ], 10, yn)) : (i(), g(b, {
          key: 1,
          model: n.value.popupModel
        }, null, 8, ["model"])),
        c.question.cssClasses.chevronButtonIconId ? (i(), u("div", {
          key: 3,
          class: a(c.question.cssClasses.chevronButton),
          onPointerdown: o,
          "aria-hidden": "true"
        }, [
          C(L, {
            class: a(c.question.cssClasses.chevronButtonSvg),
            iconName: c.question.cssClasses.chevronButtonIconId,
            size: "auto"
          }, null, 8, ["class", "iconName"])
        ], 34)) : d("", !0)
      ], 2);
    };
  }
}), hn = { style: { visibility: "hidden" } }, Cn = ["placeholder", "disabled", "inputmode", "role", "aria-expanded", "aria-controls", "aria-label", "aria-labelledby", "aria-describedby", "aria-activedescendant", "id", "readonly", "size"], bn = /* @__PURE__ */ h({
  __name: "TagboxFilter",
  props: {
    question: {},
    model: {}
  },
  setup(r) {
    const s = r, n = (l) => {
      const m = s.model;
      m.inputStringRendered = l.target.value;
    }, e = (l) => {
      s.model.inputKeyHandler(l);
    }, o = (l) => {
      s.model.onBlur(l);
    }, t = (l) => {
      s.model.onFocus(l);
    };
    return B(() => s.model), (l, m) => {
      const v = y("survey-string");
      return i(), u("div", {
        class: a(l.question.cssClasses.hint)
      }, [
        l.model.showHintPrefix ? (i(), u("div", {
          key: 0,
          class: a(l.question.cssClasses.hintPrefix)
        }, [
          p("span", null, R(l.model.hintStringPrefix), 1)
        ], 2)) : d("", !0),
        p("div", {
          class: a(l.question.cssClasses.hintSuffixWrapper)
        }, [
          l.question.showSelectedItemLocText ? (i(), g(v, {
            key: 0,
            locString: l.question.selectedItemLocText
          }, null, 8, ["locString"])) : d("", !0),
          l.model.showHintString ? (i(), u("div", {
            key: 1,
            class: a(l.question.cssClasses.hintSuffix)
          }, [
            p("span", hn, R(l.model.inputStringRendered), 1),
            p("span", null, R(l.model.hintStringSuffix), 1)
          ], 2)) : d("", !0),
          P(p("input", {
            type: "text",
            autocomplete: "off",
            "onUpdate:modelValue": m[0] || (m[0] = (c) => l.model.inputStringRendered = c),
            class: a(l.question.cssClasses.filterStringInput),
            placeholder: l.model.filterStringPlaceholder,
            disabled: l.question.isInputReadOnly,
            inputmode: l.model.inputMode,
            role: l.model.filterStringEnabled ? l.question.ariaRole : void 0,
            "aria-expanded": l.question.ariaExpanded === null ? void 0 : l.question.ariaExpanded === "true",
            "aria-controls": l.model.listElementId,
            "aria-label": l.question.a11y_input_ariaLabel,
            "aria-labelledby": l.question.a11y_input_ariaLabelledBy,
            "aria-describedby": l.question.a11y_input_ariaDescribedBy,
            "aria-activedescendant": l.model.ariaActivedescendant,
            id: l.question.getInputId(),
            readonly: l.model.filterReadOnly ? !0 : void 0,
            size: l.model.inputStringRendered ? void 0 : 1,
            onChange: n,
            onKeydown: e,
            onBlur: o,
            onFocus: t
          }, null, 42, Cn), [
            [we, l.model.inputStringRendered]
          ])
        ], 2)
      ], 2);
    };
  }
}), kn = { class: "sv-tagbox__item-text" }, fn = /* @__PURE__ */ h({
  __name: "TagboxItem",
  props: {
    question: {},
    item: {}
  },
  setup(r) {
    const s = r, n = (e) => {
      s.question.dropdownListModel.deselectItem(s.item.value), e.stopPropagation();
    };
    return B(() => s.item), (e, o) => {
      const t = y("survey-string"), l = y("sv-svg-icon");
      return i(), u("div", {
        class: "sv-tagbox__item",
        key: e.item.key
      }, [
        p("div", kn, [
          C(t, {
            locString: e.item.locText
          }, null, 8, ["locString"])
        ]),
        p("div", {
          class: a(e.question.cssClasses.cleanItemButton),
          onClick: n
        }, [
          C(l, {
            class: a(e.question.cssClasses.cleanItemButtonSvg),
            iconName: e.question.cssClasses.cleanItemButtonIconId,
            size: "auto"
          }, null, 8, ["class", "iconName"])
        ], 2)
      ]);
    };
  }
}), wn = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Ranking",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = (t) => s.question.getItemValueWrapperComponentName(t) || "survey-ranking-item", o = (t, l, m) => ({
      componentName: s.question.getPropertyByName("itemComponent").isDefaultValue(
        s.question.itemComponent
      ) ? "survey-ranking-item" : s.question.itemComponent,
      componentData: {
        question: s.question,
        item: t,
        index: l,
        unrankedItem: m,
        data: s.question.getItemValueWrapperComponentData(t)
      }
    });
    return (t, l) => {
      const m = y("survey-string");
      return i(), u("div", {
        class: a(t.question.rootClass),
        ref_key: "root",
        ref: n
      }, [
        t.question.selectToRankEnabled ? d("", !0) : (i(!0), u(_, { key: 0 }, D(t.question.rankingChoices, (v, c) => (i(), g(T(e(v)), H({
          key: v.value + "-" + c + "-item"
        }, o(v, c)), null, 16))), 128)),
        t.question.selectToRankEnabled ? (i(), u("div", {
          key: 1,
          class: a(t.question.getContainerClasses("from")),
          "data-ranking": "from-container"
        }, [
          (i(!0), u(_, null, D(t.question.unRankingChoices, (v, c) => (i(), g(T(e(v)), H({
            key: v.value + "-" + c + "-item"
          }, o(v, c, !0)), null, 16))), 128)),
          t.question.unRankingChoices.length === 0 ? (i(), u("div", {
            key: 0,
            class: a(t.question.cssClasses.containerPlaceholder)
          }, [
            C(m, {
              locString: t.question.locSelectToRankEmptyRankedAreaText
            }, null, 8, ["locString"])
          ], 2)) : d("", !0)
        ], 2)) : d("", !0),
        t.question.selectToRankEnabled ? (i(), u("div", {
          key: 2,
          class: a(t.question.cssClasses.containersDivider)
        }, null, 2)) : d("", !0),
        t.question.selectToRankEnabled ? (i(), u("div", {
          key: 3,
          class: a(t.question.getContainerClasses("to")),
          "data-ranking": "to-container"
        }, [
          (i(!0), u(_, null, D(t.question.rankingChoices, (v, c) => (i(), g(T(e(v)), H({
            key: v.value + "-" + c + "-item"
          }, o(v, c)), null, 16))), 128)),
          t.question.rankingChoices.length === 0 ? (i(), u("div", {
            key: 0,
            class: a(t.question.cssClasses.containerPlaceholder)
          }, [
            C(m, {
              locString: t.question.locSelectToRankEmptyUnrankedAreaText
            }, null, 8, ["locString"])
          ], 2)) : d("", !0)
        ], 2)) : d("", !0)
      ], 2);
    };
  }
}), In = ["tabindex", "data-sv-drop-target-ranking-item"], Sn = {
  tabindex: "-1",
  style: { outline: "none" }
}, Rn = ["xlink:href"], Tn = ["xlink:href"], $n = ["xlink:href"], _n = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "RankingItem",
  props: {
    index: {},
    question: {},
    item: {},
    unrankedItem: { type: Boolean }
  },
  setup(r) {
    const s = r, n = S(() => s.question.getNumberByIndex(s.index));
    return B(() => s.item), (e, o) => {
      const t = y("survey-string");
      return i(), u("div", {
        tabindex: e.question.getItemTabIndex(e.item),
        "data-sv-drop-target-ranking-item": e.index,
        class: a(e.question.getItemClass(e.item)),
        onKeydown: o[0] || (o[0] = (l) => {
          e.question.handleKeydown.call(e.question, l, e.item);
        }),
        onPointerdown: o[1] || (o[1] = (l) => {
          e.question.handlePointerDown.call(
            e.question,
            l,
            e.item,
            l.currentTarget
          );
        }),
        onPointerup: o[2] || (o[2] = (l) => {
          e.question.handlePointerUp.call(
            e.question,
            l,
            e.item,
            l.currentTarget
          );
        })
      }, [
        p("div", Sn, [
          p("div", {
            class: a(e.question.cssClasses.itemGhostNode)
          }, null, 2),
          p("div", {
            class: a(e.question.cssClasses.itemContent)
          }, [
            p("div", {
              class: a(e.question.cssClasses.itemIconContainer)
            }, [
              (i(), u("svg", {
                class: a(e.question.getIconHoverCss())
              }, [
                p("use", {
                  "xlink:href": e.question.dragDropSvgIcon
                }, null, 8, Rn)
              ], 2)),
              (i(), u("svg", {
                class: a(e.question.getIconFocusCss())
              }, [
                p("use", {
                  "xlink:href": e.question.arrowsSvgIcon
                }, null, 8, Tn)
              ], 2))
            ], 2),
            !e.unrankedItem && n.value ? (i(), u("div", {
              key: 0,
              class: a(e.question.getItemIndexClasses(e.item))
            }, R(n.value), 3)) : (i(), u("div", {
              key: 1,
              class: a(e.question.getItemIndexClasses(e.item))
            }, [
              (i(), u("svg", null, [
                p("use", {
                  "xlink:href": e.question.dashSvgIcon
                }, null, 8, $n)
              ]))
            ], 2)),
            p("div", {
              class: a(e.question.cssClasses.controlLabel)
            }, [
              C(t, {
                locString: e.item.locText
              }, null, 8, ["locString"])
            ], 2)
          ], 2)
        ])
      ], 42, In);
    };
  }
}), Dn = { role: "radiogroup" }, Bn = /* @__PURE__ */ p("legend", {
  role: "presentation",
  class: "sv-hidden"
}, null, -1), Ln = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Rating",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = (o) => s.question.getInputId(o);
    return (o, t) => {
      const l = y("survey-string");
      return i(), u("div", {
        class: a(o.question.ratingRootCss),
        ref_key: "root",
        ref: n
      }, [
        p("fieldset", Dn, [
          Bn,
          o.question.hasMinLabel ? (i(), u("span", {
            key: 0,
            class: a(o.question.cssClasses.minText)
          }, [
            C(l, {
              locString: o.question.locMinRateDescription
            }, null, 8, ["locString"])
          ], 2)) : d("", !0),
          (i(!0), u(_, null, D(o.question.renderedRateItems, (m, v) => (i(), g(T(o.question.itemComponent), {
            key: e(v),
            item: m,
            index: v,
            question: o.question
          }, null, 8, ["item", "index", "question"]))), 128)),
          o.question.hasMaxLabel ? (i(), u("span", {
            key: 1,
            class: a(o.question.cssClasses.maxText)
          }, [
            C(l, {
              locString: o.question.locMaxRateDescription
            }, null, 8, ["locString"])
          ], 2)) : d("", !0)
        ])
      ], 2);
    };
  }
}), Nn = ["name", "id", "value", "disabled", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Pn = /* @__PURE__ */ h({
  __name: "RatingItem",
  props: {
    question: {},
    item: {},
    index: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.item), (n, e) => {
      const o = y("survey-string");
      return i(), u("label", {
        key: n.item.value,
        onMousedown: e[1] || (e[1] = (t) => n.question.onMouseDown()),
        class: a(n.question.getItemClassByText(n.item.itemValue, n.item.text))
      }, [
        p("input", {
          type: "radio",
          class: "sv-visuallyhidden",
          name: n.question.questionName,
          id: n.question.getInputId(n.index),
          value: n.item.value,
          disabled: n.question.isInputReadOnly,
          onClick: e[0] || (e[0] = (t) => n.question.setValueFromClick(t.target.value)),
          "aria-required": n.question.ariaRequired,
          "aria-label": n.question.ariaLabel,
          "aria-invalid": n.question.ariaInvalid,
          "aria-errormessage": n.question.ariaErrormessage
        }, null, 8, Nn),
        p("span", {
          class: a(n.question.cssClasses.itemText)
        }, [
          C(o, {
            locString: n.item.locText
          }, null, 8, ["locString"])
        ], 2)
      ], 34);
    };
  }
}), An = ["name", "id", "value", "disabled", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Mn = /* @__PURE__ */ h({
  __name: "RatingItemSmiley",
  props: {
    question: {},
    item: {},
    index: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.item), (n, e) => {
      const o = y("sv-svg-icon");
      return i(), u("label", {
        key: n.item.value,
        onMousedown: e[1] || (e[1] = (t) => n.question.onMouseDown()),
        style: I(n.question.getItemStyle(n.item.itemValue, n.item.highlight)),
        class: a(n.question.getItemClass(n.item.itemValue, n.item.highlight)),
        onMouseover: e[2] || (e[2] = (t) => n.question.onItemMouseIn(n.item)),
        onMouseleave: e[3] || (e[3] = (t) => n.question.onItemMouseOut(n.item))
      }, [
        p("input", {
          type: "radio",
          class: "sv-visuallyhidden",
          name: n.question.questionName,
          id: n.question.getInputId(n.index),
          value: n.item.value,
          disabled: n.question.isInputReadOnly,
          onClick: e[0] || (e[0] = (t) => n.question.setValueFromClick(t.target.value)),
          "aria-required": n.question.ariaRequired,
          "aria-label": n.question.ariaLabel,
          "aria-invalid": n.question.ariaInvalid,
          "aria-errormessage": n.question.ariaErrormessage
        }, null, 8, An),
        C(o, {
          iconName: n.question.getItemSmileyIconName(n.item.itemValue),
          size: "auto",
          title: n.item.text
        }, null, 8, ["iconName", "title"])
      ], 38);
    };
  }
}), En = ["name", "id", "value", "disabled", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Hn = /* @__PURE__ */ h({
  __name: "RatingItemStar",
  props: {
    question: {},
    item: {},
    index: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.item), (n, e) => {
      const o = y("sv-svg-icon");
      return i(), u("label", {
        key: n.item.value,
        onMousedown: e[1] || (e[1] = (t) => n.question.onMouseDown()),
        class: a(n.question.getItemClass(n.item.itemValue)),
        onMouseover: e[2] || (e[2] = (t) => n.question.onItemMouseIn(n.item)),
        onMouseleave: e[3] || (e[3] = (t) => n.question.onItemMouseOut(n.item))
      }, [
        p("input", {
          type: "radio",
          class: "sv-visuallyhidden",
          name: n.question.questionName,
          id: n.question.getInputId(n.index),
          value: n.item.value,
          disabled: n.question.isInputReadOnly,
          onClick: e[0] || (e[0] = (t) => n.question.setValueFromClick((t == null ? void 0 : t.target).value)),
          "aria-required": n.question.ariaRequired,
          "aria-label": n.question.ariaLabel,
          "aria-invalid": n.question.ariaInvalid,
          "aria-errormessage": n.question.ariaErrormessage
        }, null, 8, En),
        C(o, {
          class: a("sv-star"),
          iconName: n.question.itemStarIcon,
          size: "auto",
          title: n.item.text
        }, null, 8, ["iconName", "title"]),
        C(o, {
          class: a("sv-star-2"),
          iconName: n.question.itemStarIconAlt,
          size: "auto",
          title: n.item.text
        }, null, 8, ["iconName", "title"])
      ], 34);
    };
  }
}), Wn = { class: "sd-rating-dropdown-item" }, Vn = { class: "sd-rating-dropdown-item_text" }, Fn = {
  key: 0,
  class: "sd-rating-dropdown-item_description"
}, On = /* @__PURE__ */ h({
  __name: "RatingDropdownItem",
  props: {
    item: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.item), (n, e) => {
      const o = y("survey-string");
      return i(), u("div", Wn, [
        p("span", Vn, R(n.item.title), 1),
        n.item.description ? (i(), u("div", Fn, [
          C(o, {
            locString: n.item.description
          }, null, 8, ["locString"])
        ])) : d("", !0)
      ]);
    };
  }
});
ee.Instance.registerRenderer(
  "rating",
  "dropdown",
  "sv-rating-dropdown"
);
const zn = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "RatingDropdown",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      const t = y("sv-dropdown");
      return i(), u("div", {
        class: a(e.question.cssClasses.rootDropdown),
        ref_key: "root",
        ref: n
      }, [
        C(t, { question: e.question }, null, 8, ["question"])
      ], 2);
    };
  }
}), Un = ["name", "value", "id", ".indeterminate", "disabled", "role", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], Kn = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "BooleanSwitch",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = (t, l) => {
      s.question.onLabelClick(t, l);
    }, o = (t) => {
      s.question.onSwitchClickModel(t);
    };
    return (t, l) => {
      var v;
      const m = y("survey-string");
      return i(), u("div", {
        class: a(t.question.cssClasses.root),
        ref_key: "root",
        ref: n,
        onKeydown: l[4] || (l[4] = (c) => t.question.onKeyDownCore(c))
      }, [
        p("label", {
          class: a(t.question.getItemCss())
        }, [
          P(p("input", {
            type: "checkbox",
            name: t.question.name,
            value: (v = t.question.booleanValue) != null ? v : "",
            "onUpdate:modelValue": l[0] || (l[0] = (c) => t.question.booleanValue = c),
            class: a(t.question.cssClasses.control),
            id: t.question.inputId,
            ".indeterminate": t.question.isIndeterminate,
            disabled: t.question.isInputReadOnly,
            role: t.question.a11y_input_ariaRole,
            "aria-required": t.question.a11y_input_ariaRequired,
            "aria-label": t.question.a11y_input_ariaLabel,
            "aria-labelledby": t.question.a11y_input_ariaLabelledBy,
            "aria-describedby": t.question.a11y_input_ariaDescribedBy,
            "aria-invalid": t.question.a11y_input_ariaInvalid,
            "aria-errormessage": t.question.a11y_input_ariaErrormessage
          }, null, 42, Un), [
            [oe, t.question.booleanValue]
          ]),
          p("div", {
            class: a(t.question.cssClasses.sliderGhost),
            onClick: l[1] || (l[1] = (c) => e(c, t.question.swapOrder))
          }, [
            p("span", {
              class: a(t.question.getLabelCss(t.question.swapOrder))
            }, [
              C(m, {
                locString: t.question.locLabelLeft
              }, null, 8, ["locString"])
            ], 2)
          ], 2),
          p("div", {
            class: a(t.question.cssClasses.switch),
            onClick: l[2] || (l[2] = (c) => o(c))
          }, [
            p("span", {
              class: a(t.question.cssClasses.slider),
              style: I({ marginLeft: t.question.thumbMargin })
            }, [
              t.question.cssClasses.sliderText && t.question.isDeterminated ? (i(), u("span", {
                key: 0,
                class: a(t.question.cssClasses.sliderText)
              }, [
                C(m, {
                  locString: t.question.getCheckedLabel()
                }, null, 8, ["locString"])
              ], 2)) : d("", !0)
            ], 6)
          ], 2),
          p("div", {
            class: a(t.question.cssClasses.sliderGhost),
            onClick: l[3] || (l[3] = (c) => e(c, !t.question.swapOrder))
          }, [
            p("span", {
              class: a(t.question.getLabelCss(!t.question.swapOrder))
            }, [
              C(m, {
                locString: t.question.locLabelRight
              }, null, 8, ["locString"])
            ], 2)
          ], 2)
        ], 2)
      ], 34);
    };
  }
});
ee.Instance.registerRenderer(
  "boolean",
  "radio",
  "sv-boolean-radio"
);
const Qn = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "BooleanRadio",
  props: {
    question: {}
  },
  setup(r) {
    const s = $(null);
    return A(r, s), (e, o) => {
      const t = y("sv-boolean-radio-item");
      return i(), u("div", {
        class: a(e.question.cssClasses.rootRadio),
        ref_key: "root",
        ref: s
      }, [
        p("fieldset", {
          role: "presentation",
          class: a(e.question.cssClasses.radioFieldset)
        }, [
          e.question.swapOrder ? (i(), g(t, {
            key: !0,
            question: e.question,
            locText: e.question.locLabelTrue,
            value: !0
          }, null, 8, ["question", "locText"])) : d("", !0),
          (i(), g(t, {
            key: !1,
            question: e.question,
            locText: e.question.locLabelFalse,
            value: !1
          }, null, 8, ["question", "locText"])),
          e.question.swapOrder ? d("", !0) : (i(), g(t, {
            key: !0,
            question: e.question,
            locText: e.question.locLabelTrue,
            value: !0
          }, null, 8, ["question", "locText"]))
        ], 2)
      ], 2);
    };
  }
}), jn = ["name", "value", "checked", "aria-errormessage", "disabled"], Gn = ["xlink:href"], Jn = /* @__PURE__ */ h({
  __name: "BooleanRadioItem",
  props: {
    question: {},
    locText: {},
    value: { type: Boolean }
  },
  setup(r) {
    const s = r, n = (e) => {
      const o = s.question;
      o.booleanValue = e.target.value == "true";
    };
    return (e, o) => {
      const t = y("survey-string");
      return i(), u("div", {
        role: "presentation",
        class: a(e.question.getRadioItemClass(e.question.cssClasses, e.value))
      }, [
        p("label", {
          class: a(e.question.cssClasses.radioLabel)
        }, [
          p("input", {
            type: "radio",
            name: e.question.name,
            value: e.value,
            checked: e.value === e.question.booleanValueRendered,
            "aria-errormessage": e.question.ariaErrormessage,
            disabled: e.question.isInputReadOnly,
            class: a(e.question.cssClasses.itemRadioControl),
            onChange: n
          }, null, 42, jn),
          e.question.cssClasses.materialRadioDecorator ? (i(), u("span", {
            key: 0,
            class: a(e.question.cssClasses.materialRadioDecorator)
          }, [
            e.question.itemSvgIcon ? (i(), u("svg", {
              key: 0,
              class: a(e.question.cssClasses.itemRadioDecorator)
            }, [
              p("use", {
                "xlink:href": e.question.itemSvgIcon
              }, null, 8, Gn)
            ], 2)) : d("", !0)
          ], 2)) : d("", !0),
          p("span", {
            class: a(e.question.cssClasses.radioControlLabel)
          }, [
            C(t, { locString: e.locText }, null, 8, ["locString"])
          ], 2)
        ], 2)
      ], 2);
    };
  }
}), Xn = ["name", "value", "id", ".indeterminate", "disabled", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Yn = ["xlink:href"], Zn = /* @__PURE__ */ p("span", { class: "check" }, null, -1), xn = ["id"], eo = ["id"];
ee.Instance.registerRenderer(
  "boolean",
  "checkbox",
  "sv-boolean-checkbox"
);
const so = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "BooleanCheckbox",
  props: {
    question: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      var v;
      const t = y("survey-element-title-content"), l = y("sv-title-actions"), m = y("survey-string");
      return i(), u("div", {
        class: a(e.question.cssClasses.rootCheckbox),
        ref_key: "root",
        ref: n
      }, [
        p("div", {
          class: a(e.question.getCheckboxItemCss())
        }, [
          p("label", {
            class: a(e.question.cssClasses.checkboxLabel)
          }, [
            P(p("input", {
              type: "checkbox",
              name: e.question.name,
              value: (v = e.question.booleanValue) != null ? v : "",
              "onUpdate:modelValue": o[0] || (o[0] = (c) => e.question.booleanValue = c),
              class: a(e.question.cssClasses.controlCheckbox),
              id: e.question.inputId,
              ".indeterminate": e.question.isIndeterminate,
              disabled: e.question.isInputReadOnly,
              "aria-required": e.question.ariaRequired,
              "aria-label": e.question.ariaLabel,
              "aria-invalid": e.question.ariaInvalid,
              "aria-errormessage": e.question.ariaErrormessage
            }, null, 42, Xn), [
              [oe, e.question.booleanValue]
            ]),
            p("span", {
              class: a(e.question.cssClasses.checkboxMaterialDecorator)
            }, [
              e.question.svgIcon ? (i(), u("svg", {
                key: 0,
                class: a(e.question.cssClasses.checkboxItemDecorator)
              }, [
                p("use", {
                  "xlink:href": e.question.svgIcon
                }, null, 8, Yn)
              ], 2)) : d("", !0),
              Zn
            ], 2),
            e.question.isLabelRendered ? (i(), u("span", {
              key: 0,
              id: e.question.labelRenderedAriaID,
              class: a(e.question.cssClasses.checkboxControlLabel)
            }, [
              e.question.hasTitleActions ? d("", !0) : (i(), g(t, {
                key: 0,
                element: e.question,
                css: e.css
              }, null, 8, ["element", "css"])),
              e.question.hasTitleActions ? (i(), g(l, {
                key: 1,
                element: e.question,
                css: e.css
              }, null, 8, ["element", "css"])) : d("", !0)
            ], 10, xn)) : d("", !0)
          ], 2),
          e.question.canRenderLabelDescription ? (i(), u("div", {
            key: 0,
            class: a(e.question.cssDescription),
            id: e.question.ariaDescriptionId
          }, [
            C(m, {
              locString: e.question.locDescription
            }, null, 8, ["locString"])
          ], 10, eo)) : d("", !0)
        ], 2)
      ], 2);
    };
  }
}), no = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Multipletext",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null), e = le(() => s.question.getRows());
    return A(s, n), (o, t) => {
      const l = y("survey-multipletext-item");
      return i(), u("table", {
        class: a(o.question.getQuestionRootCss()),
        ref_key: "root",
        ref: n
      }, [
        p("tbody", null, [
          (i(!0), u(_, null, D(w(e), (m, v) => (i(), u(_, {
            key: o.question.inputId + "rowkey" + v
          }, [
            m.isVisible ? (i(), u("tr", {
              key: 0,
              class: a(o.question.cssClasses.row)
            }, [
              (i(!0), u(_, null, D(m.cells, (c) => (i(), u("td", {
                key: "item" + c.item.editor.id,
                class: a(c.className)
              }, [
                C(l, {
                  question: o.question,
                  cell: c
                }, null, 8, ["question", "cell"])
              ], 2))), 128))
            ], 2)) : d("", !0)
          ], 64))), 128))
        ])
      ], 2);
    };
  }
}), oo = { key: 1 }, to = /* @__PURE__ */ h({
  __name: "MultipletextItem",
  props: {
    question: {},
    cell: {}
  },
  setup(r) {
    const s = r, n = (o) => re(o);
    B(() => s.cell.item.editor);
    const e = S(() => s.cell.item);
    return (o, t) => {
      const l = y("survey-string"), m = y("survey-errors");
      return o.cell.isErrorsCell ? (i(), g(m, {
        key: 1,
        element: e.value.editor
      }, null, 8, ["element"])) : (i(), u("label", {
        key: 0,
        class: a(o.question.getItemLabelCss(e.value))
      }, [
        p("span", {
          class: a(o.question.getItemTitleCss()),
          style: I({ minWidth: o.question.itemTitleWidth, width: o.question.itemTitleWidth })
        }, [
          e.value.editor.isRequireTextBeforeTitle || e.value.editor.isRequireTextOnStart ? (i(), u("span", {
            key: 0,
            class: a(o.question.cssClasses.requiredText)
          }, R(e.value.editor.requiredText), 3)) : d("", !0),
          C(l, {
            locString: e.value.locTitle
          }, null, 8, ["locString"]),
          e.value.editor.isRequireTextAfterTitle ? (i(), u("span", oo, "\xA0")) : d("", !0),
          e.value.editor.isRequireTextAfterTitle ? (i(), u("span", {
            key: 2,
            "aria-hidden": "true",
            class: a(o.question.cssClasses.requiredText)
          }, R(e.value.editor.requiredText), 3)) : d("", !0)
        ], 6),
        (i(), u("div", {
          key: e.value.editor.id,
          class: a(o.question.getItemCss()),
          onFocusin: t[0] || (t[0] = (v) => e.value.focusIn())
        }, [
          (i(), g(T(n(e.value.editor)), {
            question: e.value.editor
          }, null, 8, ["question"]))
        ], 34))
      ], 2));
    };
  }
}), io = { class: "sv-hidden" }, ro = { key: 0 }, lo = { key: 0 }, ao = ["onClick"], uo = ["data-responsive-title", "onClick"], mo = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Matrix",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null), e = U();
    A(
      s,
      n,
      (t) => {
        e.value = t.visibleRows, t.visibleRowsChangedCallback = () => {
          e.value = t.visibleRows;
        };
      },
      (t) => {
        t.visibleRowsChangedCallback = () => {
        };
      }
    );
    const o = (t, l) => {
      t.value = l.value;
    };
    return (t, l) => {
      const m = y("survey-string");
      return i(), u("div", {
        class: a(t.question.cssClasses.tableWrapper),
        ref_key: "root",
        ref: n
      }, [
        p("fieldset", null, [
          p("legend", io, R(t.question.locTitle.renderedHtml), 1),
          p("table", {
            class: a(t.question.getTableCss())
          }, [
            t.question.showHeader ? (i(), u("thead", ro, [
              p("tr", null, [
                t.question.hasRows ? (i(), u("td", lo)) : d("", !0),
                (i(!0), u(_, null, D(t.question.visibleColumns, (v, c) => (i(), u("th", {
                  key: c,
                  class: a(t.question.cssClasses.headerCell),
                  style: I({
                    minWidth: t.question.columnMinWidth,
                    width: t.question.columnMinWidth
                  })
                }, [
                  (i(), g(T(t.question.getColumnHeaderWrapperComponentName(v)), {
                    componentData: t.question.getColumnHeaderWrapperComponentData(v)
                  }, {
                    default: F(() => [
                      C(m, {
                        locString: v.locText
                      }, null, 8, ["locString"])
                    ]),
                    _: 2
                  }, 1032, ["componentData"]))
                ], 6))), 128))
              ])
            ])) : d("", !0),
            p("tbody", null, [
              (i(!0), u(_, null, D(e.value, (v, c) => (i(), u("tr", {
                key: "row_" + v.name + "_" + c,
                class: a(v.rowClasses || void 0)
              }, [
                P(p("td", {
                  class: a(v.rowTextClasses),
                  style: I({
                    minWidth: t.question.rowTitleWidth,
                    width: t.question.rowTitleWidth
                  })
                }, [
                  (i(), g(T(t.question.getRowHeaderWrapperComponentName(v)), {
                    componentData: t.question.getRowHeaderWrapperComponentData(v)
                  }, {
                    default: F(() => [
                      C(m, {
                        locString: v.locText
                      }, null, 8, ["locString"])
                    ]),
                    _: 2
                  }, 1032, ["componentData"]))
                ], 6), [
                  [E, t.question.hasRows]
                ]),
                t.question.hasCellText ? (i(!0), u(_, { key: 0 }, D(t.question.visibleColumns, (q, f) => (i(), u("td", {
                  key: f,
                  class: a(t.question.getItemClass(v, q)),
                  onClick: (k) => o(v, q)
                }, [
                  C(m, {
                    locString: t.question.getCellDisplayLocText(v.name, q)
                  }, null, 8, ["locString"])
                ], 10, ao))), 128)) : d("", !0),
                t.question.hasCellText ? d("", !0) : (i(!0), u(_, { key: 1 }, D(t.question.visibleColumns, (q, f) => (i(), u("td", {
                  key: f,
                  "data-responsive-title": q.locText.renderedHtml,
                  class: a(t.question.cssClasses.cell),
                  onClick: (k) => o(v, q)
                }, [
                  (i(), g(T(t.question.cellComponent), {
                    question: t.question,
                    row: v,
                    column: q,
                    columnIndex: f
                  }, null, 8, ["question", "row", "column", "columnIndex"]))
                ], 10, uo))), 128))
              ], 2))), 128))
            ])
          ], 2)
        ])
      ], 2);
    };
  }
}), co = ["data-sv-drop-target-matrix-row"], po = /* @__PURE__ */ h({
  __name: "MatrixRow",
  props: {
    question: {},
    row: {}
  },
  setup(r) {
    const s = r, n = $();
    B(() => s.row);
    const e = K(
      () => s.row,
      (o, t) => {
        t && t.setRootElement(void 0), o.setRootElement(n.value);
      }
    );
    return M(() => {
      s.row.setRootElement(n.value);
    }), O(() => {
      s.row.setRootElement(void 0), e();
    }), (o, t) => {
      const l = y("survey-matrixdropdown-cell");
      return o.row.visible ? (i(), u("tr", {
        key: 0,
        "data-sv-drop-target-matrix-row": o.row.row && o.row.row.id,
        onPointerdown: t[0] || (t[0] = (m) => o.question.onPointerDown(m, o.row.row)),
        class: a(o.row.className),
        ref_key: "root",
        ref: n
      }, [
        (i(!0), u(_, null, D(o.row.cells, (m, v) => (i(), g(l, {
          cell: m,
          question: o.question,
          key: o.row.id + "_" + v
        }, null, 8, ["cell", "question"]))), 128))
      ], 42, co)) : d("", !0);
    };
  }
}), vo = ["name", "value", "disabled", "id", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], qo = ["xlink:href"], yo = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "MatrixCell",
  props: {
    question: {},
    row: {},
    column: {},
    columnIndex: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("survey-string");
      return i(), u("label", {
        onMousedown: n[1] || (n[1] = (o) => s.question.onMouseDown()),
        class: a(s.question.getItemClass(s.row, s.column))
      }, [
        P(p("input", {
          type: "radio",
          class: a(s.question.cssClasses.itemValue),
          name: s.row.fullName,
          "onUpdate:modelValue": n[0] || (n[0] = (o) => s.row.value = o),
          value: s.column.value,
          disabled: s.row.isReadOnly,
          id: s.question.inputId + "_" + s.row.name + "_" + s.columnIndex,
          "aria-required": s.question.a11y_input_ariaRequired,
          "aria-label": s.question.getCellAriaLabel(
            s.row.locText.renderedHtml,
            s.column.locText.renderedHtml
          ),
          "aria-invalid": s.question.a11y_input_ariaInvalid,
          "aria-errormessage": s.question.a11y_input_ariaErrormessage
        }, null, 10, vo), [
          [x, s.row.value]
        ]),
        p("span", {
          class: a(s.question.cssClasses.materialDecorator)
        }, [
          s.question.itemSvgIcon ? (i(), u("svg", {
            key: 0,
            class: a(s.question.cssClasses.itemDecorator)
          }, [
            p("use", {
              "xlink:href": s.question.itemSvgIcon
            }, null, 8, qo)
          ], 2)) : d("", !0)
        ], 2),
        s.question.isMobile ? (i(), u("span", {
          key: 0,
          class: a(s.question.cssClasses.cellResponsiveTitle)
        }, [
          C(e, {
            locString: s.column.locText
          }, null, 8, ["locString"])
        ], 2)) : d("", !0)
      ], 34);
    };
  }
}), go = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "MatrixDropdown",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    return A(s, n), (e, o) => {
      const t = y("survey-matrixtable");
      return i(), g(t, {
        question: e.question,
        ref_key: "root",
        ref: n
      }, null, 8, ["question"]);
    };
  }
}), ho = { key: 0 }, Co = { key: 1 }, bo = /* @__PURE__ */ h({
  __name: "MatrixTable",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = S(() => s.question.renderedTable);
    return B(
      () => n.value,
      (e) => {
        const o = ie();
        e.renderedRowsChangedCallback = () => {
          var t;
          (t = o == null ? void 0 : o.proxy) == null || t.$forceUpdate();
        };
      },
      (e) => {
        e.renderedRowsChangedCallback = () => {
        };
      }
    ), (e, o) => {
      const t = y("survey-string"), l = y("survey-matrixheaderrequired"), m = y("survey-matrix-row"), v = y("survey-matrixdropdown-cell");
      return i(), u("div", {
        style: I({ overflowX: e.question.showHorizontalScroll ? "scroll" : "" }),
        class: a(e.question.cssClasses.tableWrapper)
      }, [
        p("table", {
          class: a(e.question.getTableCss())
        }, [
          n.value.showHeader ? (i(), u("thead", ho, [
            p("tr", null, [
              (i(!0), u(_, null, D(n.value.headerRow.cells, (c) => (i(), u(_, null, [
                c.hasTitle ? (i(), u("th", {
                  key: "header_" + c.id,
                  class: a(c.className),
                  style: I({ minWidth: c.minWidth, width: c.width })
                }, [
                  (i(), g(T(e.question.getColumnHeaderWrapperComponentName(c)), {
                    componentData: e.question.getColumnHeaderWrapperComponentData(c)
                  }, {
                    default: F(() => [
                      C(t, {
                        locString: c.locTitle
                      }, null, 8, ["locString"]),
                      c.column ? (i(), g(l, {
                        key: 0,
                        column: c.column,
                        question: e.question
                      }, null, 8, ["column", "question"])) : d("", !0)
                    ]),
                    _: 2
                  }, 1032, ["componentData"]))
                ], 6)) : d("", !0),
                c.hasTitle ? d("", !0) : (i(), u("td", {
                  class: a(c.className),
                  key: "header_" + c.id,
                  style: I({ minWidth: c.minWidth, width: c.width })
                }, null, 6))
              ], 64))), 256))
            ])
          ])) : d("", !0),
          p("tbody", null, [
            (i(!0), u(_, null, D(n.value.renderedRows, (c) => (i(), g(m, {
              key: e.question.inputId + "_" + c.id,
              row: c,
              question: e.question
            }, null, 8, ["row", "question"]))), 128))
          ]),
          n.value.showFooter ? (i(), u("tfoot", Co, [
            p("tr", null, [
              (i(!0), u(_, null, D(n.value.footerRow.cells, (c, q) => (i(), g(v, {
                cell: c,
                question: e.question,
                key: "footer_" + q
              }, null, 8, ["cell", "question"]))), 128))
            ])
          ])) : d("", !0)
        ], 2)
      ], 6);
    };
  }
}), ko = /* @__PURE__ */ p("span", null, "\xA0", -1), fo = /* @__PURE__ */ h({
  __name: "MatrixHeaderRequired",
  props: {
    question: {},
    column: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.column), (n, e) => n.column.isRenderedRequired ? (i(), u(_, { key: 0 }, [
      ko,
      n.column.isRenderedRequired ? (i(), u("span", {
        key: 0,
        class: a(n.question.cssClasses.cellRequiredText)
      }, R(n.column.requiredText), 3)) : d("", !0)
    ], 64)) : d("", !0);
  }
}), wo = ["data-responsive-title", "title", "colspan"], Io = /* @__PURE__ */ h({
  __name: "MatrixDropdownCellComp",
  props: {
    question: {},
    cell: {}
  },
  setup(r) {
    const s = r, n = $(!1), e = $(), o = () => s.cell.headers, t = () => !!s.cell.width || !!s.cell.minWidth ? { width: s.cell.width, minWidth: s.cell.minWidth } : null, l = () => n.value = s.cell.question.isVisible, m = (q) => re(q);
    M(() => {
      if (!s.cell.hasQuestion || !s.question || !s.question.survey)
        return;
      l(), s.cell.question.registerPropertyChangedHandlers(["isVisible"], () => {
        l();
      });
      const q = e.value, f = s.cell.question, k = {
        cell: s.cell.cell,
        cellQuestion: f,
        htmlElement: q,
        row: s.cell.row,
        column: s.cell.cell.column
      };
      s.question.survey.matrixAfterCellRender(s.question, k), f && f.afterRenderCore(q);
    });
    const v = S(() => {
      const q = s.cell;
      if (q.hasPanel) {
        const f = q.panel, k = f.survey;
        if (k) {
          const L = k.getElementWrapperComponentName(f);
          if (L)
            return L;
        }
        return "survey-panel";
      }
    }), c = S(() => {
      if (s.cell.hasPanel) {
        const f = s.cell.panel, k = f.survey;
        let L;
        return k && (L = k.getElementWrapperComponentData(f)), {
          componentName: "survey-panel",
          componentData: {
            element: f,
            data: L,
            css: s.question.cssClasses
          }
        };
      }
    });
    return (q, f) => {
      const k = y("survey-errors"), L = y("sv-matrix-drag-drop-icon"), b = y("sv-action-bar"), N = y("survey-radiogroup-item"), W = y("survey-checkbox-item"), V = y("survey-other-choice"), Q = y("survey-string");
      return i(), u("td", {
        class: a(q.cell.className),
        "data-responsive-title": o(),
        title: q.cell.getTitle(),
        style: I(t()),
        colspan: q.cell.colSpans,
        onFocusin: f[0] || (f[0] = (ue) => q.cell.focusIn()),
        ref_key: "root",
        ref: e
      }, [
        q.cell.isErrorsCell ? (i(), g(k, {
          key: 0,
          element: q.cell.question
        }, null, 8, ["element"])) : d("", !0),
        q.cell.isDragHandlerCell ? (i(), g(L, {
          key: 1,
          item: { data: { row: q.cell.row, question: q.question } }
        }, null, 8, ["item"])) : d("", !0),
        q.cell.isActionsCell ? (i(), g(b, {
          key: 2,
          model: q.cell.item.getData(),
          handleClick: !1
        }, null, 8, ["model"])) : d("", !0),
        q.cell.hasPanel ? (i(), g(T(v.value), z(H({ key: 3 }, c.value)), null, 16)) : d("", !0),
        q.cell.hasQuestion ? P((i(), u("div", {
          key: 4,
          class: a(q.cell.cellQuestionWrapperClassName)
        }, [
          !q.cell.isChoice && q.cell.question.isDefaultRendering() ? (i(), g(T(q.question.getCellWrapperComponentName(q.cell.cell)), {
            key: 0,
            componentData: q.question.getCellWrapperComponentData(q.cell.cell)
          }, {
            default: F(() => [
              (i(), g(T(m(q.cell.question)), {
                question: q.cell.question
              }, null, 8, ["question"]))
            ]),
            _: 1
          }, 8, ["componentData"])) : d("", !0),
          !q.cell.isChoice && !q.cell.question.isDefaultRendering() ? (i(), g(T(q.cell.question.getComponentName()), {
            key: 1,
            question: q.cell.question
          }, null, 8, ["question"])) : d("", !0),
          q.cell.isItemChoice ? (i(), g(T(q.question.getCellWrapperComponentName(q.cell.cell)), {
            key: 2,
            componentData: q.question.getCellWrapperComponentData(q.cell.cell)
          }, {
            default: F(() => [
              q.cell.isRadio ? (i(), g(N, {
                key: q.cell.item.value,
                question: q.cell.question,
                item: q.cell.item,
                hideLabel: !0
              }, null, 8, ["question", "item"])) : d("", !0),
              q.cell.isCheckbox ? (i(), g(W, {
                key: q.cell.item.value,
                question: q.cell.question,
                item: q.cell.item,
                hideLabel: !0
              }, null, 8, ["question", "item"])) : d("", !0)
            ]),
            _: 1
          }, 8, ["componentData"])) : d("", !0),
          q.cell.isOtherChoice ? (i(), g(V, {
            key: 3,
            question: q.cell.question
          }, null, 8, ["question"])) : d("", !0)
        ], 2)), [
          [E, n.value]
        ]) : d("", !0),
        q.cell.hasTitle ? (i(), g(T(q.question.getCellWrapperComponentName(q.cell)), {
          key: 5,
          componentData: q.question.getCellWrapperComponentData(q.cell)
        }, {
          default: F(() => [
            q.cell.hasTitle ? (i(), g(Q, {
              key: 0,
              locString: q.cell.locTitle
            }, null, 8, ["locString"])) : d("", !0),
            q.cell.requiredText ? (i(), u("span", {
              key: 1,
              class: a(q.question.cssClasses.cellRequiredText)
            }, R(q.cell.requiredText), 3)) : d("", !0)
          ]),
          _: 1
        }, 8, ["componentData"])) : d("", !0)
      ], 46, wo);
    };
  }
}), So = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "MatrixDynamic",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = () => {
      s.question.addRowUI();
    };
    return (o, t) => {
      const l = y("survey-string"), m = y("survey-matrixtable");
      return i(), u("div", {
        ref_key: "root",
        ref: n
      }, [
        o.question.renderedTable.showAddRowOnTop ? (i(), u("div", {
          key: 0,
          class: a(o.question.cssClasses.footer)
        }, [
          p("button", {
            type: "button",
            class: a(o.question.getAddRowButtonCss()),
            onClick: e
          }, [
            C(l, {
              locString: o.question.locAddRowText
            }, null, 8, ["locString"]),
            p("span", {
              class: a(o.question.cssClasses.iconAdd)
            }, null, 2)
          ], 2)
        ], 2)) : d("", !0),
        o.question.renderedTable.showTable ? (i(), g(m, {
          key: 1,
          question: o.question
        }, null, 8, ["question"])) : d("", !0),
        o.question.renderedTable.showTable ? d("", !0) : (i(), u("div", {
          key: 2,
          class: a(o.question.cssClasses.emptyRowsSection)
        }, [
          p("div", {
            class: a(o.question.cssClasses.emptyRowsText)
          }, [
            C(l, {
              locString: o.question.locEmptyRowsText
            }, null, 8, ["locString"])
          ], 2),
          o.question.renderedTable.showAddRow ? (i(), u("button", {
            key: 0,
            type: "button",
            class: a(o.question.getAddRowButtonCss(!0)),
            onClick: e
          }, [
            C(l, {
              locString: o.question.locAddRowText
            }, null, 8, ["locString"]),
            p("span", {
              class: a(o.question.cssClasses.iconAdd)
            }, null, 2)
          ], 2)) : d("", !0)
        ], 2)),
        o.question.renderedTable.showAddRowOnBottom ? (i(), u("div", {
          key: 3,
          class: a(o.question.cssClasses.footer)
        }, [
          p("button", {
            type: "button",
            class: a(o.question.getAddRowButtonCss()),
            onClick: e
          }, [
            C(l, {
              locString: o.question.locAddRowText
            }, null, 8, ["locString"]),
            p("span", {
              class: a(o.question.cssClasses.iconAdd)
            }, null, 2)
          ], 2)
        ], 2)) : d("", !0)
      ], 512);
    };
  }
});
function ae(r, s = !0) {
  return {
    question: S(() => r.item.data.question),
    row: s ? S(() => r.item.data.row) : void 0
  };
}
const Ro = ["disabled"], To = /* @__PURE__ */ h({
  __name: "RemoveButton",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, { question: n, row: e } = ae(s);
    return (o, t) => {
      const l = y("survey-string");
      return i(), u("button", {
        type: "button",
        class: a(w(n).getRemoveRowButtonCss()),
        disabled: w(n).isInputReadOnly,
        onClick: t[0] || (t[0] = () => w(n).removeRowUI(w(e)))
      }, [
        C(l, {
          locString: w(n).locRemoveRowText
        }, null, 8, ["locString"]),
        p("span", {
          class: a(w(n).cssClasses.iconRemove)
        }, null, 2)
      ], 10, Ro);
    };
  }
}), $o = ["xlink:href"], _o = /* @__PURE__ */ h({
  __name: "DragDropIcon",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, { question: n } = ae(s, !1);
    return (e, o) => w(n).iconDragElement ? (i(), u("svg", {
      key: 0,
      class: a(w(n).cssClasses.dragElementDecorator)
    }, [
      p("use", {
        "xlink:href": w(n).iconDragElement
      }, null, 8, $o)
    ], 2)) : (i(), u("span", {
      key: 1,
      class: a(w(n).cssClasses.iconDrag)
    }, null, 2));
  }
}), Do = ["aria-expanded", "aria-controls"], Bo = /* @__PURE__ */ h({
  __name: "DetailButton",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, { question: n, row: e } = ae(s);
    return (o, t) => {
      const l = y("sv-svg-icon");
      return i(), u("button", {
        type: "button",
        class: a(w(n).getDetailPanelButtonCss(w(e))),
        onClick: t[0] || (t[0] = () => w(e).showHideDetailPanelClick()),
        "aria-expanded": w(n).getIsDetailPanelShowing(w(e)) ? "true" : "false",
        "aria-controls": w(n).getIsDetailPanelShowing(w(e)) ? w(e).detailPanelId : null
      }, [
        C(l, {
          class: a(w(n).getDetailPanelIconCss(w(e))),
          iconName: w(n).getDetailPanelIconId(w(e)),
          size: "auto"
        }, null, 8, ["class", "iconName"])
      ], 10, Do);
    };
  }
}), Lo = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "PanelDynamic",
  props: {
    question: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(null), e = ie();
    A(
      s,
      n,
      (m) => {
        m.panelCountChangedCallback = () => {
          var v;
          (v = e == null ? void 0 : e.proxy) == null || v.$forceUpdate();
        }, m.currentIndexChangedCallback = () => {
          var v;
          (v = e == null ? void 0 : e.proxy) == null || v.$forceUpdate();
        }, m.renderModeChangedCallback = () => {
          var v;
          (v = e == null ? void 0 : e.proxy) == null || v.$forceUpdate();
        };
      },
      (m) => {
        m.panelCountChangedCallback = () => {
        }, m.currentIndexChangedCallback = () => {
        }, m.renderModeChangedCallback = () => {
        };
      }
    );
    const o = () => s.question.showLegacyNavigation, t = (m) => {
      const v = s.question.getSurvey();
      if (v) {
        const c = v.getElementWrapperComponentName(m);
        if (c)
          return c;
      }
      return "panel";
    }, l = (m) => {
      const v = s.question.getSurvey();
      let c;
      return v && (c = v.getElementWrapperComponentData(m)), {
        componentName: "survey-panel",
        componentData: {
          element: m,
          data: c
        }
      };
    };
    return (m, v) => {
      const c = y("survey-string"), q = y("sv-paneldynamic-add-btn"), f = y("survey-paneldynamicprogress"), k = y("sv-paneldynamic-remove-btn"), L = y("survey-paneldynamicprogress-v2");
      return i(), u("div", {
        class: a(m.question.cssClasses.root),
        ref_key: "root",
        ref: n
      }, [
        m.question.getShowNoEntriesPlaceholder() ? (i(), u("div", {
          key: 0,
          class: a(m.question.cssClasses.noEntriesPlaceholder)
        }, [
          p("span", null, [
            C(c, {
              locString: m.question.locNoEntriesText
            }, null, 8, ["locString"])
          ]),
          C(q, {
            data: { question: m.question }
          }, null, 8, ["data"])
        ], 2)) : d("", !0),
        !o() && m.question.isProgressTopShowing && m.question.isRangeShowing ? (i(), u("div", {
          key: 1,
          class: a(m.question.cssClasses.progress)
        }, [
          p("div", {
            class: a(m.question.cssClasses.progressBar),
            style: I({ width: m.question.progress }),
            role: "progressbar"
          }, null, 6)
        ], 2)) : d("", !0),
        o() && m.question.isProgressTopShowing ? (i(), g(f, {
          key: 2,
          question: m.question
        }, null, 8, ["question"])) : d("", !0),
        p("div", {
          class: a(m.question.cssClasses.panelsContainer)
        }, [
          (i(!0), u(_, null, D(m.question.renderedPanels, (b, N) => (i(), u(_, {
            key: b.id
          }, [
            p("div", {
              class: a(m.question.getPanelWrapperCss(b))
            }, [
              (i(), g(T(t(b)), z(ne(l(b))), null, 16)),
              m.question.panelRemoveButtonLocation === "right" && m.question.canRemovePanel && b.state !== "collapsed" ? (i(), g(k, {
                key: 0,
                data: { question: m.question, panel: b }
              }, null, 8, ["data"])) : d("", !0)
            ], 2),
            m.question.isRenderModeList && N < m.question.visiblePanelCount - 1 ? (i(), u("hr", {
              class: a(m.question.cssClasses.separator),
              key: "separator" + b.id
            }, null, 2)) : d("", !0)
          ], 64))), 128))
        ], 2),
        o() && m.question.isProgressBottomShowing ? (i(), g(f, {
          key: 3,
          question: m.question
        }, null, 8, ["question"])) : d("", !0),
        o() && m.question.isRenderModeList ? (i(), g(q, {
          key: 4,
          data: { question: m.question }
        }, null, 8, ["data"])) : d("", !0),
        m.question.showNavigation ? (i(), g(L, {
          key: 5,
          question: m.question
        }, null, 8, ["question"])) : d("", !0)
      ], 2);
    };
  }
}), No = /* @__PURE__ */ h({
  __name: "PanelDynamicProgress",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = () => s.question.isProgressTopShowing ? s.question.cssClasses.progressTop : s.question.cssClasses.progressBottom;
    return (e, o) => {
      const t = y("sv-paneldynamic-prev-btn"), l = y("sv-paneldynamic-next-btn"), m = y("sv-paneldynamic-add-btn"), v = y("sv-paneldynamic-progress-text");
      return i(), u("div", {
        class: a(n())
      }, [
        p("div", {
          style: { clear: "both" },
          class: a(n())
        }, [
          p("div", {
            class: a(e.question.cssClasses.progressContainer)
          }, [
            C(t, {
              data: { question: e.question }
            }, null, 8, ["data"]),
            e.question.isRangeShowing ? (i(), u("div", {
              key: 0,
              class: a(e.question.cssClasses.progress)
            }, [
              p("div", {
                class: a(e.question.cssClasses.progressBar),
                style: I({ width: e.question.progress }),
                role: "progressbar"
              }, null, 6)
            ], 2)) : d("", !0),
            C(l, {
              data: { question: e.question }
            }, null, 8, ["data"])
          ], 2),
          C(m, {
            data: { question: e.question }
          }, null, 8, ["data"]),
          C(v, {
            data: { question: e.question }
          }, null, 8, ["data"])
        ], 2)
      ], 2);
    };
  }
}), Po = /* @__PURE__ */ h({
  __name: "PanelDynamicProgressV2",
  props: {
    question: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("sv-action-bar");
      return s.question.cssClasses.footer ? (i(), u("div", {
        key: 0,
        class: a(s.question.cssClasses.footer)
      }, [
        p("hr", {
          class: a(s.question.cssClasses.separator)
        }, null, 2),
        s.question.isRangeShowing && s.question.isProgressBottomShowing ? (i(), u("div", {
          key: 0,
          class: a(s.question.cssClasses.progress)
        }, [
          p("div", {
            class: a(s.question.cssClasses.progressBar),
            style: I({ width: s.question.progress }),
            role: "progressbar"
          }, null, 6)
        ], 2)) : d("", !0),
        s.question.footerToolbar.visibleActions.length ? (i(), u("div", {
          key: 1,
          class: a(s.question.cssClasses.footerButtonsContainer)
        }, [
          C(e, {
            model: s.question.footerToolbar
          }, null, 8, ["model"])
        ], 2)) : d("", !0)
      ], 2)) : d("", !0);
    };
  }
});
function Y(r) {
  return S(
    () => r.item && r.item.data.question || r.data.question
  );
}
const Ao = /* @__PURE__ */ h({
  __name: "PaneldynamicAddBtn",
  props: {
    item: {},
    data: {}
  },
  setup(r) {
    const n = Y(r), e = () => {
      n.value.addPanelUI();
    };
    return (o, t) => {
      const l = y("survey-string");
      return w(n).canAddPanel ? (i(), u("button", {
        key: 0,
        type: "button",
        class: a(w(n).getAddButtonCss()),
        onClick: e
      }, [
        p("span", {
          class: a(w(n).cssClasses.buttonAddText)
        }, [
          C(l, {
            locString: w(n).locPanelAddText
          }, null, 8, ["locString"])
        ], 2)
      ], 2)) : d("", !0);
    };
  }
}), Mo = ["title"], Eo = /* @__PURE__ */ h({
  __name: "PaneldynamicNextBtn",
  props: {
    item: {},
    data: {}
  },
  setup(r) {
    const n = Y(r), e = () => {
      n.value.goToNextPanel();
    };
    return (o, t) => {
      const l = y("sv-svg-icon");
      return i(), u("div", {
        title: w(n).panelNextText,
        onClick: e,
        class: a(w(n).getNextButtonCss())
      }, [
        C(l, {
          iconName: w(n).cssClasses.progressBtnIcon,
          size: "auto"
        }, null, 8, ["iconName"])
      ], 10, Mo);
    };
  }
}), Ho = ["title"], Wo = /* @__PURE__ */ h({
  __name: "PaneldynamicPrevBtn",
  props: {
    item: {},
    data: {}
  },
  setup(r) {
    const n = Y(r), e = () => {
      n.value.goToPrevPanel();
    };
    return (o, t) => {
      const l = y("sv-svg-icon");
      return i(), u("div", {
        title: w(n).panelPrevText,
        onClick: e,
        class: a(w(n).getPrevButtonCss())
      }, [
        C(l, {
          iconName: w(n).cssClasses.progressBtnIcon,
          size: "auto"
        }, null, 8, ["iconName"])
      ], 10, Ho);
    };
  }
}), Vo = /* @__PURE__ */ h({
  __name: "PaneldynamicRemoveBtn",
  props: {
    item: {},
    data: {}
  },
  setup(r) {
    const s = r, n = Y(s), e = S(
      () => s.item && s.item.data.panel || s.data.panel
    ), o = (t) => {
      n.value.isInputReadOnly || n.value.removePanelUI(t);
    };
    return (t, l) => {
      const m = y("survey-string");
      return i(), u("button", {
        type: "button",
        class: a(w(n).getPanelRemoveButtonCss()),
        onClick: l[0] || (l[0] = (v) => o(e.value))
      }, [
        p("span", {
          class: a(w(n).cssClasses.buttonRemoveText)
        }, [
          C(m, {
            locString: w(n).locPanelRemoveText
          }, null, 8, ["locString"])
        ], 2),
        p("span", {
          class: a(w(n).cssClasses.iconRemove)
        }, null, 2)
      ], 2);
    };
  }
}), Fo = /* @__PURE__ */ h({
  __name: "PaneldynamicProgressText",
  props: {
    item: {},
    data: {}
  },
  setup(r) {
    const n = Y(r);
    return (e, o) => (i(), u("div", {
      class: a(w(n).cssClasses.progressText)
    }, R(w(n).progressText), 3));
  }
}), Oo = ["id"], zo = /* @__PURE__ */ h({
  __name: "Errors",
  props: {
    element: {},
    location: {}
  },
  setup(r) {
    const s = $();
    return (n, e) => n.element.hasVisibleErrors ? (i(), u("div", {
      key: 0,
      role: "alert",
      "aria-live": "polite",
      class: a(n.element.cssError),
      id: n.element.id + "_errors",
      ref_key: "root",
      ref: s
    }, [
      (i(!0), u(_, null, D(n.element.errors, (o, t) => (i(), g(T(n.element.survey.questionErrorComponent), {
        element: n.element,
        key: "error_" + t,
        errorKey: "error_" + t,
        error: o,
        cssClasses: n.element.cssClasses
      }, null, 8, ["element", "errorKey", "error", "cssClasses"]))), 128))
    ], 10, Oo)) : d("", !0);
  }
}), Uo = { key: 0 }, Ko = ["id", "readonly", "disabled", "value", "maxlength", "placeholder", "aria-label", "aria-required"], Qo = /* @__PURE__ */ h({
  __name: "QuestionComment",
  props: {
    question: {}
  },
  setup(r) {
    return (s, n) => s.question.isReadOnlyRenderDiv() ? (i(), u("div", Uo, R(s.question.comment), 1)) : (i(), u("textarea", {
      key: 1,
      id: s.question.commentId,
      readonly: s.question.isInputReadOnly,
      disabled: s.question.isInputReadOnly,
      class: a(s.question.cssClasses.other),
      value: s.question.comment,
      maxlength: s.question.getOthersMaxLength(),
      placeholder: s.question.renderedCommentPlaceholder,
      "aria-label": s.question.ariaLabel || s.question.a11y_input_ariaLabel,
      "aria-required": s.question.ariaRequired || s.question.a11y_input_ariaRequired,
      style: I({ resize: s.question.resizeStyle }),
      onChange: n[0] || (n[0] = (e) => {
        s.question.onCommentChange(e);
      }),
      onInput: n[1] || (n[1] = (e) => {
        s.question.onCommentInput(e);
      })
    }, null, 46, Ko));
  }
}), jo = /* @__PURE__ */ h({
  __name: "TitleElement",
  props: {
    element: {},
    css: {}
  },
  setup(r) {
    const s = (n) => {
      ye(n);
    };
    return (n, e) => {
      const o = y("survey-element-title-content"), t = y("sv-title-actions");
      return n.element.hasTitle ? (i(), g(T(n.element.titleTagName), {
        key: 0,
        class: a(n.element.cssTitle),
        "aria-label": n.element.titleAriaLabel,
        id: n.element.ariaTitleId,
        tabindex: n.element.titleTabIndex,
        "aria-expanded": n.element.titleAriaExpanded,
        role: n.element.titleAriaRole,
        onKeyup: e[0] || (e[0] = (l) => {
          s(l);
        })
      }, {
        default: F(() => [
          n.element.hasTitleActions ? d("", !0) : (i(), g(o, {
            key: 0,
            element: n.element,
            css: n.css
          }, null, 8, ["element", "css"])),
          n.element.hasTitleActions ? (i(), g(t, {
            key: 1,
            element: n.element,
            css: n.css
          }, null, 8, ["element", "css"])) : d("", !0)
        ]),
        _: 1
      }, 40, ["class", "aria-label", "id", "tabindex", "aria-expanded", "role"])) : d("", !0);
    };
  }
}), Go = { key: 3 }, Jo = { key: 5 }, Xo = { key: 7 }, Yo = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "TitleContent",
  props: {
    element: {},
    css: {}
  },
  setup(r) {
    const s = r, n = S(
      () => (s.element.isPanel ? s.element.cssClasses.panel : s.element.cssClasses) || {}
    );
    return (e, o) => {
      const t = y("survey-string");
      return i(), u(_, null, [
        e.element.isTitleRenderedAsString ? (i(), g(t, {
          key: 0,
          locString: e.element.locTitle
        }, null, 8, ["locString"])) : d("", !0),
        !e.element.isTitleRenderedAsString && e.element.isRequireTextOnStart ? (i(), u("span", {
          key: 1,
          class: a(n.value.requiredText),
          "aria-hidden": !0
        }, R(e.element.requiredText), 3)) : d("", !0),
        !e.element.isTitleRenderedAsString && e.element.no ? (i(), u("span", {
          key: 2,
          style: { position: "static" },
          class: a(e.element.cssTitleNumber),
          "aria-hidden": !0
        }, R(e.element.no), 3)) : d("", !0),
        !e.element.isTitleRenderedAsString && e.element.no ? (i(), u("span", Go, "\xA0")) : d("", !0),
        !e.element.isTitleRenderedAsString && e.element.isRequireTextBeforeTitle ? (i(), u("span", {
          key: 4,
          class: a(n.value.requiredText),
          "aria-hidden": !0
        }, R(e.element.requiredText), 3)) : d("", !0),
        !e.element.isTitleRenderedAsString && e.element.isRequireTextBeforeTitle ? (i(), u("span", Jo, "\xA0")) : d("", !0),
        e.element.isTitleRenderedAsString ? d("", !0) : (i(), g(t, {
          key: 6,
          locString: e.element.locTitle
        }, null, 8, ["locString"])),
        !e.element.isTitleRenderedAsString && e.element.isRequireTextAfterTitle ? (i(), u("span", Xo, "\xA0")) : d("", !0),
        !e.element.isTitleRenderedAsString && e.element.isRequireTextAfterTitle ? (i(), u("span", {
          key: 8,
          class: a(n.value.requiredText),
          "aria-hidden": !0
        }, R(e.element.requiredText), 3)) : d("", !0)
      ], 64);
    };
  }
}), Zo = { class: "sv-title-actions" }, xo = { class: "sv-title-actions__title" }, et = /* @__PURE__ */ h({
  __name: "TitleActions",
  props: {
    element: {},
    css: {}
  },
  setup(r) {
    const s = r, n = S(() => s.element.getTitleToolbar());
    return (e, o) => {
      const t = y("survey-string"), l = y("survey-element-title-content"), m = y("sv-action-bar");
      return i(), u("div", Zo, [
        p("span", xo, [
          e.element.isPage ? (i(), g(t, {
            key: 0,
            locString: e.element.locTitle
          }, null, 8, ["locString"])) : d("", !0),
          e.element.isPage ? d("", !0) : (i(), g(l, {
            key: 1,
            element: e.element,
            css: e.css
          }, null, 8, ["element", "css"]))
        ]),
        C(m, { model: n.value }, null, 8, ["model"])
      ]);
    };
  }
}), he = (r, s) => {
  const n = r.__vccOpts || r;
  for (const [e, o] of s)
    n[e] = o;
  return n;
}, st = {}, nt = { class: "sv-brand-info" }, ot = /* @__PURE__ */ Ie('<a class="sv-brand-info__logo" href="https://surveyjs.io/?utm_source=built-in_links&amp;utm_medium=online_survey_tool&amp;utm_campaign=landing_page"><img src="https://surveyjs.io/Content/Images/poweredby.svg"></a><div class="sv-brand-info__text"> Try and see how easy it is to <a href="https://surveyjs.io/create-survey?utm_source=built-in_links&amp;utm_medium=online_survey_tool&amp;utm_campaign=create_survey">create a survey</a></div><div class="sv-brand-info__terms"><a href="https://surveyjs.io/TermsOfUse">Terms of Use &amp; Privacy Statement</a></div>', 3), tt = [
  ot
];
function it(r, s) {
  return i(), u("div", nt, tt);
}
const rt = /* @__PURE__ */ he(st, [["render", it]]), lt = /* @__PURE__ */ p("use", null, null, -1), at = [
  lt
], ut = /* @__PURE__ */ h({
  __name: "SvgIcon",
  props: {
    size: {},
    width: {},
    height: {},
    iconName: {},
    title: {}
  },
  setup(r) {
    const s = r, n = $(), e = () => {
      Ne(
        s.size,
        s.width,
        s.height,
        s.iconName,
        n.value,
        s.title
      );
    };
    return te(() => {
      e();
    }), M(() => {
      e();
    }), (o, t) => (i(), u("svg", {
      ref_key: "svgIconElement",
      ref: n,
      class: "sv-svg-icon",
      role: "img"
    }, at, 512));
  }
}), dt = /* @__PURE__ */ h({
  __name: "QuestionError",
  props: {
    errorKey: {},
    error: {},
    cssClasses: {},
    element: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("survey-string");
      return i(), u("div", { key: s.errorKey }, [
        p("span", {
          class: a(
            s.cssClasses ? s.cssClasses.error.icon || void 0 : "panel-error-icon"
          ),
          "aria-hidden": "true"
        }, null, 2),
        p("span", {
          class: a(
            s.cssClasses ? s.cssClasses.error.item || void 0 : "panel-error-item"
          )
        }, [
          C(e, {
            locString: s.error.locText
          }, null, 8, ["locString"])
        ], 2)
      ]);
    };
  }
}), mt = /* @__PURE__ */ h({
  __name: "ActionBar",
  props: {
    model: {},
    container: {},
    handleClick: { type: Boolean, default: !0 }
  },
  setup(r) {
    const s = r, n = $(null), e = (t) => {
      s.handleClick && t.stopPropagation();
    };
    B(() => s.model);
    const o = le(() => s.model.renderedActions);
    return M(() => {
      !s.model.hasActions || s.model.initResponsivityManager(n.value);
    }), O(() => {
      s.model.resetResponsivityManager();
    }), (t, l) => {
      const m = y("sv-action");
      return t.model.hasActions ? (i(), u("div", {
        key: 0,
        ref_key: "root",
        ref: n,
        class: a(t.model.getRootCss()),
        onClick: e
      }, [
        (i(!0), u(_, null, D(w(o), (v) => (i(), g(m, {
          key: v.id,
          item: v
        }, null, 8, ["item"]))), 128))
      ], 2)) : d("", !0);
    };
  }
}), ct = ["id"], pt = { class: "sv-action__content" }, vt = /* @__PURE__ */ h({
  __name: "Action",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, n = S(
      () => s.item.component || "sv-action-bar-item"
    );
    return B(() => s.item), (e, o) => {
      const t = y("sv-action-bar-separator");
      return i(), u("div", {
        class: a(e.item.getActionRootCss()),
        id: e.item.id
      }, [
        p("div", pt, [
          e.item.needSeparator ? (i(), g(t, { key: 0 })) : d("", !0),
          (i(), g(T(n.value), { item: e.item }, null, 8, ["item"]))
        ])
      ], 10, ct);
    };
  }
}), qt = ["disabled", "title", "aria-checked", "aria-expanded", "role"], yt = {
  inheritAttrs: !1
}, gt = /* @__PURE__ */ h({
  ...yt,
  __name: "ActionBarItem",
  props: {
    item: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.item), (n, e) => {
      const o = y("sv-svg-icon"), t = X("key2click");
      return P((i(), u("button", {
        class: a(n.item.getActionBarItemCss()),
        type: "button",
        onClick: e[0] || (e[0] = (l) => {
          n.item.action(n.item, !!l.pointerType);
        }),
        onKeyup: e[1] || (e[1] = (l) => {
          l.stopPropagation();
        }),
        disabled: n.item.disabled,
        title: n.item.tooltip || n.item.title,
        "aria-checked": n.item.ariaChecked,
        "aria-expanded": n.item.ariaExpanded,
        role: n.item.ariaRole
      }, [
        n.item.iconName ? (i(), g(o, {
          key: 0,
          class: a(n.item.cssClasses.itemIcon),
          iconName: n.item.iconName,
          size: n.item.iconSize,
          title: n.item.tooltip || n.item.title
        }, null, 8, ["class", "iconName", "size", "title"])) : d("", !0),
        n.item.hasTitle ? (i(), u("span", {
          key: 1,
          class: a(n.item.getActionBarItemTitleCss())
        }, R(n.item.title), 3)) : d("", !0)
      ], 42, qt)), [
        [t, { processEsc: !1, disableTabStop: n.item.disableTabStop }]
      ]);
    };
  }
}), ht = ["disabled", "title", "role"], Ct = {
  inheritAttrs: !1
}, bt = /* @__PURE__ */ h({
  ...Ct,
  __name: "ActionBarItemDropdown",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, n = Ae;
    let e;
    return B(
      () => s.item,
      (o) => {
        e = new Pe(o);
      },
      () => {
        e.dispose();
      }
    ), (o, t) => {
      const l = y("sv-svg-icon"), m = y("sv-popup"), v = X("key2click");
      return i(), u(_, null, [
        P((i(), u("button", {
          type: "button",
          class: a(o.item.getActionBarItemCss()),
          onClick: t[0] || (t[0] = (c) => {
            o.item.action(o.item, !!c.pointerType);
          }),
          onKeyup: t[1] || (t[1] = (c) => {
            c.stopPropagation();
          }),
          disabled: o.item.disabled,
          title: o.item.tooltip || o.item.title,
          role: o.item.ariaRole
        }, [
          o.item.iconName ? (i(), g(l, {
            key: 0,
            class: a(o.item.cssClasses.itemIcon),
            iconName: o.item.iconName,
            size: o.item.iconSize,
            title: o.item.tooltip || o.item.title
          }, null, 8, ["class", "iconName", "size", "title"])) : d("", !0),
          o.item.hasTitle ? (i(), u("span", {
            key: 1,
            class: a(o.item.getActionBarItemTitleCss())
          }, R(o.item.title), 3)) : d("", !0)
        ], 42, ht)), [
          [v, { processEsc: !1, disableTabStop: o.item.disableTabStop }]
        ]),
        C(m, {
          model: o.item.popupModel,
          getTarget: w(n)
        }, null, 8, ["model", "getTarget"])
      ], 64);
    };
  }
}), kt = /* @__PURE__ */ h({
  __name: "ActionBarSeparator",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, n = S(() => s.item && s.item.innerCss);
    return (e, o) => (i(), u("div", {
      class: a(["sv-action-bar-separator", n.value])
    }, null, 2));
  }
}), ft = ["aria-label", "placeholder", "value"], wt = ["aria-label"], It = ["id"], St = /* @__PURE__ */ h({
  __name: "List",
  props: {
    model: {}
  },
  setup(r) {
    const s = r, n = $(null), e = (l) => {
      const m = s.model;
      m.filterString = l.target.value;
    }, o = (l) => {
      const m = s.model;
      m.filterString = l.target.value, s.model.goToItems(l);
    }, t = (l) => {
      s.model.onMouseMove(l);
    };
    return B(() => s.model), M(() => {
      s.model.initListContainerHtmlElement(n.value);
    }), (l, m) => {
      const v = y("sv-svg-icon"), c = y("sv-list-item");
      return i(), u("div", {
        class: a(l.model.cssClasses.root),
        ref_key: "listContainerElement",
        ref: n
      }, [
        l.model.showFilter ? (i(), u("div", {
          key: 0,
          class: a(l.model.cssClasses.filter)
        }, [
          p("div", {
            class: a(l.model.cssClasses.filterIcon)
          }, [
            C(v, {
              iconName: "icon-search",
              size: "auto"
            })
          ], 2),
          p("input", {
            type: "text",
            class: a(l.model.cssClasses.filterInput),
            "aria-label": l.model.filterStringPlaceholder,
            placeholder: l.model.filterStringPlaceholder,
            value: l.model.filterString,
            onChange: e,
            onKeyup: o
          }, null, 42, ft),
          l.model.showSearchClearButton && !!l.model.filterString ? (i(), u("button", {
            key: 0,
            onClick: m[0] || (m[0] = (q) => {
              l.model.onClickSearchClearButton(q);
            }),
            class: a(l.model.cssClasses.searchClearButtonIcon)
          }, [
            C(v, {
              iconName: "icon-searchclear",
              size: "auto"
            })
          ], 2)) : d("", !0)
        ], 2)) : d("", !0),
        P(p("div", {
          class: a(l.model.cssClasses.emptyContainer)
        }, [
          p("div", {
            class: a(l.model.cssClasses.emptyText),
            "aria-label": l.model.emptyMessage
          }, R(l.model.emptyMessage), 11, wt)
        ], 2), [
          [E, l.model.isEmpty]
        ]),
        l.model.renderElements ? P((i(), u("ul", {
          key: 1,
          class: a(l.model.getListClass()),
          role: "listbox",
          id: l.model.elementId,
          onMousedown: m[1] || (m[1] = (q) => {
            q.preventDefault();
          }),
          onMousemove: t,
          onKeydown: m[2] || (m[2] = (q) => {
            l.model.onKeyDown(q);
          })
        }, [
          (i(!0), u(_, null, D(l.model.renderedActions, (q) => (i(), g(c, {
            item: q,
            model: l.model,
            key: q.id
          }, null, 8, ["item", "model"]))), 128))
        ], 42, It)), [
          [E, !l.model.isEmpty]
        ]) : d("", !0)
      ], 2);
    };
  }
}), Rt = ["aria-selected", "id", "tabindex"], Tt = ["title"], $t = /* @__PURE__ */ h({
  __name: "ListItem",
  props: {
    model: {},
    item: {}
  },
  setup(r) {
    const s = r, n = S(() => s.item.elementId), e = (o) => {
      s.model.onItemClick(s.item), o.stopPropagation();
    };
    return B(() => s.item), M(() => {
      setTimeout(() => {
        s.model.onLastItemRended(s.item);
      });
    }), (o, t) => {
      const l = y("sv-svg-icon"), m = y("survey-string"), v = X("key2click");
      return P((i(), u("li", {
        role: "option",
        "aria-selected": o.model.isItemSelected(o.item),
        key: o.item.id,
        id: n.value,
        onPointerdown: t[0] || (t[0] = (c) => o.model.onPointerDown(c, o.item)),
        class: a(o.model.getItemClass(o.item)),
        onClick: e,
        tabindex: o.item.disableTabStop ? -1 : 0
      }, [
        o.item.needSeparator ? (i(), u("div", {
          key: 0,
          class: a(o.model.cssClasses.itemSeparator)
        }, null, 2)) : d("", !0),
        p("div", {
          style: I({ paddingInlineStart: o.model.getItemIndent(o.item) }),
          class: a(o.model.cssClasses.itemBody),
          title: o.item.locTitle.calculatedText
        }, [
          o.item.iconName && !o.item.component ? (i(), g(l, {
            key: 0,
            class: a(o.model.cssClasses.itemIcon),
            iconName: o.item.iconName,
            size: o.item.iconSize
          }, null, 8, ["class", "iconName", "size"])) : d("", !0),
          o.item.component ? d("", !0) : (i(), g(m, {
            key: 1,
            locString: o.item.locTitle
          }, null, 8, ["locString"])),
          o.item.component ? (i(), g(T(o.item.component), {
            key: 2,
            item: o.item
          }, null, 8, ["item"])) : d("", !0)
        ], 14, Tt)
      ], 42, Rt)), [
        [E, o.model.isItemVisible(o.item)],
        [v, { processEsc: !1, disableTabStop: o.item.disableTabStop }]
      ]);
    };
  }
}), _t = /* @__PURE__ */ h({
  __name: "Popup",
  props: {
    getTarget: { type: Function },
    model: {}
  },
  setup(r) {
    const s = r, n = U(), e = $(null);
    return K(
      () => s.model,
      (o) => {
        n.value && n.value.dispose(), n.value = Me(o, void 0);
      },
      { immediate: !0 }
    ), B(() => n.value), M(() => {
      const o = e.value;
      n.value.setComponentElement(
        o,
        s.getTarget ? s.getTarget(o) : void 0
      );
    }), O(() => {
      n.value.dispose();
    }), (o, t) => {
      const l = y("sv-popup-container");
      return i(), u("div", {
        ref_key: "root",
        ref: e
      }, [
        C(l, { model: n.value }, null, 8, ["model"])
      ], 512);
    };
  }
}), Dt = { class: "sv-popup__shadow" }, Bt = { class: "sv-popup__body-content" }, Lt = {
  key: 0,
  class: "sv-popup__body-header"
}, Nt = { class: "sv-popup__scrolling-content" }, Pt = { class: "sv-popup__content" }, At = {
  key: 1,
  class: "sv-popup__body-footer"
}, Mt = /* @__PURE__ */ h({
  __name: "PopupContainer",
  props: {
    model: {}
  },
  setup(r) {
    const s = r, n = (e) => {
      e.stopPropagation();
    };
    return B(() => s.model), te(() => {
      const e = s.model;
      e.isVisible && !e.isPositionSet && s.model.updateOnShowing();
    }), M(() => {
      s.model.isVisible && s.model.updateOnShowing();
    }), (e, o) => {
      const t = y("sv-action-bar");
      return P((i(), u("div", {
        tabindex: "-1",
        class: a(["sv-popup", e.model.styleClass]),
        onKeydown: o[0] || (o[0] = (l) => {
          e.model.onKeyDown(l);
        }),
        onClick: o[1] || (o[1] = (l) => {
          e.model.clickOutside(l);
        })
      }, [
        p("div", {
          class: "sv-popup__container",
          style: I({
            left: e.model.left,
            top: e.model.top,
            height: e.model.height,
            width: e.model.width,
            minWidth: e.model.minWidth
          }),
          onClick: n
        }, [
          p("div", Dt, [
            e.model.showHeader ? (i(), g(T(e.model.popupHeaderTemplate), {
              key: 0,
              model: e.model
            }, null, 8, ["model"])) : d("", !0),
            p("div", Bt, [
              e.model.title ? (i(), u("div", Lt, R(e.model.title), 1)) : d("", !0),
              p("div", Nt, [
                p("div", Pt, [
                  (i(), g(T(e.model.contentComponentName), z(ne(e.model.contentComponentData)), null, 16))
                ])
              ]),
              e.model.showFooter ? (i(), u("div", At, [
                C(t, {
                  model: e.model.footerToolbar
                }, null, 8, ["model"])
              ])) : d("", !0)
            ])
          ])
        ], 4)
      ], 34)), [
        [E, e.model.isVisible]
      ]);
    };
  }
}), Et = /* @__PURE__ */ h({
  __name: "PopupPointer",
  props: {
    model: {}
  },
  setup(r) {
    return (s, n) => (i(), u("span", {
      class: "sv-popup__pointer",
      style: I({
        left: s.model.pointerTarget.left,
        top: s.model.pointerTarget.top
      })
    }, null, 4));
  }
}), Ht = {
  key: 0,
  class: "sv-components-column"
}, Wt = /* @__PURE__ */ h({
  __name: "Container",
  props: {
    survey: {},
    container: {},
    needRenderWrapper: {}
  },
  setup(r) {
    const s = r, n = S(
      () => s.survey.getContainerContent(s.container)
    );
    return (e, o) => n.value.length > 0 ? (i(), u(_, { key: 0 }, [
      e.needRenderWrapper ? (i(), u("div", Ht, [
        (i(!0), u(_, null, D(n.value, (t, l) => (i(), g(T(t.component), {
          survey: e.survey,
          container: e.container,
          model: t.data
        }, null, 8, ["survey", "container", "model"]))), 256))
      ])) : (i(!0), u(_, { key: 1 }, D(n.value, (t, l) => (i(), g(T(t.component), {
        survey: e.survey,
        container: e.container,
        model: t.data
      }, null, 8, ["survey", "container", "model"]))), 256))
    ], 64)) : d("", !0);
  }
}), Z = /* @__PURE__ */ h({
  __name: "Progress",
  props: {
    survey: {},
    container: {},
    css: {}
  },
  setup(r) {
    const s = r, n = S(() => s.survey.progressValue + "%"), e = (t) => de.getProgressTextInBarCss(t), o = (t) => de.getProgressTextUnderBarCss(t);
    return (t, l) => (i(), u("div", {
      class: a(t.survey.getProgressCssClasses(t.container))
    }, [
      p("div", {
        class: a(t.survey.css.progressBar),
        style: I({ width: n.value }),
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-label": "progress"
      }, [
        p("span", {
          class: a(e(t.survey.css))
        }, R(t.survey.progressText), 3)
      ], 6),
      p("span", {
        class: a(o(t.survey.css))
      }, R(t.survey.progressText), 3)
    ], 2));
  }
}), Vt = ["title"], Ft = ["onClick", "data-page-number"], Ot = ["title"], zt = ["title"], Ut = ["title"], Kt = /* @__PURE__ */ h({
  __name: "ProgressButtons",
  props: {
    survey: {},
    model: {},
    container: {}
  },
  setup(r) {
    const s = r, n = $(!1), e = $(!1), o = $(!1), t = $(!0), l = $(), m = S(() => s.survey.css);
    let v = null;
    const c = (q) => {
      let f = l.value;
      f.scrollLeft += (q ? -1 : 1) * 70;
    };
    return M(() => {
      const q = l.value;
      v = new Ee(s.model, q, {
        onResize: (f) => {
          t.value = f, e.value = !f;
        },
        onUpdateScroller: (f) => {
          n.value = f;
        },
        onUpdateSettings: () => {
          t.value = s.model.showItemTitles, o.value = !s.model.showItemTitles;
        },
        container: S(() => s.container)
      });
    }), G(() => {
      v.dispose();
    }), (q, f) => {
      const k = y("survey-string");
      return i(), u("div", {
        class: a(q.model.getRootCss(q.container)),
        style: I({ maxWidth: q.model.progressWidth }),
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-label": "progress"
      }, [
        e.value ? (i(), u("div", {
          key: 0,
          class: a(q.survey.css.progressButtonsHeader)
        }, [
          p("div", {
            class: a(q.survey.css.progressButtonsPageTitle),
            title: q.model.headerText
          }, R(q.model.headerText), 11, Vt)
        ], 2)) : d("", !0),
        p("div", {
          class: a(m.value.progressButtonsContainer)
        }, [
          p("div", {
            class: a(q.model.getScrollButtonCss(n.value, !0)),
            onClick: f[0] || (f[0] = (L) => c(!0)),
            role: "button"
          }, null, 2),
          p("div", {
            class: a(m.value.progressButtonsListContainer),
            ref_key: "progressButtonsListContainer",
            ref: l
          }, [
            p("ul", {
              class: a(m.value.progressButtonsList)
            }, [
              (i(!0), u(_, null, D(q.survey.visiblePages, (L, b) => (i(), u("li", {
                key: "listelement" + b,
                class: a(q.model.getListElementCss(b)),
                onClick: (N) => q.model.isListElementClickable(b) ? q.model.clickListElement(L) : null,
                "data-page-number": q.model.getItemNumber(L)
              }, [
                p("div", {
                  class: a(m.value.progressButtonsConnector)
                }, null, 2),
                t.value ? (i(), u("div", {
                  key: 0,
                  class: a(m.value.progressButtonsPageTitle),
                  title: L.renderedNavigationTitle
                }, [
                  C(k, {
                    locString: L.locNavigationTitle
                  }, null, 8, ["locString"])
                ], 10, Ot)) : d("", !0),
                t.value ? (i(), u("div", {
                  key: 1,
                  class: a(m.value.progressButtonsPageDescription),
                  title: L.locNavigationDescription.renderedHtml
                }, R(L.locNavigationDescription.renderedHtml), 11, zt)) : d("", !0),
                p("div", {
                  class: a(m.value.progressButtonsButton)
                }, [
                  p("div", {
                    class: a(m.value.progressButtonsButtonBackground)
                  }, null, 2),
                  p("div", {
                    class: a(m.value.progressButtonsButtonContent)
                  }, null, 2),
                  p("span", null, R(q.model.getItemNumber(L)), 1)
                ], 2)
              ], 10, Ft))), 128))
            ], 2)
          ], 2),
          p("div", {
            class: a(q.model.getScrollButtonCss(n.value, !1)),
            onClick: f[1] || (f[1] = (L) => c(!1)),
            role: "button"
          }, null, 2)
        ], 2),
        o.value ? (i(), u("div", {
          key: 1,
          class: a(q.survey.css.progressButtonsFooter)
        }, [
          p("div", {
            class: a(q.survey.css.progressButtonsPageTitle),
            title: q.model.footerText
          }, R(q.model.footerText), 11, Ut)
        ], 2)) : d("", !0)
      ], 6);
    };
  }
}), Qt = /* @__PURE__ */ h({
  __name: "ProgressToc",
  props: {
    survey: {},
    model: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("sv-svg-icon"), o = y("sv-popup"), t = y("sv-list"), l = X("key2click");
      return i(), u("div", {
        class: a(s.model.containerCss)
      }, [
        s.model.isMobile ? P((i(), u("div", {
          key: 0,
          onClick: n[0] || (n[0] = (...m) => s.model.togglePopup && s.model.togglePopup(...m))
        }, [
          C(e, {
            iconName: s.model.icon,
            size: 24
          }, null, 8, ["iconName"]),
          C(o, {
            model: s.model.popupModel
          }, null, 8, ["model"])
        ])), [
          [l]
        ]) : (i(), g(t, {
          key: 1,
          model: s.model.listModel
        }, null, 8, ["model"]))
      ], 2);
    };
  }
}), jt = { onsubmit: "return false;" }, Gt = {
  key: 0,
  class: "sv_custom_header"
}, Jt = { class: "sv-components-column sv-components-column--expandable" }, Xt = ["id"], Yt = { key: 2 }, Zt = ["innerHTML"], xt = ["innerHTML"], ei = ["innerHTML"], pe = /* @__PURE__ */ h({
  __name: "Survey",
  props: {
    model: {},
    survey: {}
  },
  setup(r) {
    const s = r, n = $(), e = $(""), o = $(1), t = S(() => {
      const k = s.survey ? s.survey : s.model;
      return Se(k);
    }), l = S(() => t.value.activePage ? t.value.activePage.id : ""), m = () => {
      const k = l.value;
      return !!t.value && k + o.value.toString();
    }, v = S(
      () => t.value.showCompletedPage && t.value.state === "completed"
    ), c = S(() => t.value.css), q = S(() => "page" + m()), f = () => v.value ? (e.value || (e.value = t.value.processedCompletedHtml), e.value) : "";
    return B(() => t.value), M(() => {
      if (!!t.value) {
        var k = n.value;
        k && t.value.afterRenderSurvey(k), t.value.renderCallback = () => {
          var L, b;
          o.value++, (b = (L = ie()) == null ? void 0 : L.proxy) == null || b.$forceUpdate();
        }, t.value.startTimerFromUI();
      }
    }), O(() => {
      t.value.stopTimer(), t.value.renderCallback = void 0;
    }), (k, L) => {
      const b = y("sv-svg-bundle"), N = y("survey-popup-modal"), W = y("survey-header"), V = y("survey-page"), Q = y("sv-brand-info"), ue = y("sv-notifier");
      return i(), u("div", {
        class: a(t.value.getRootCss()),
        style: I(t.value.themeVariables),
        ref_key: "root",
        ref: n
      }, [
        t.value.needRenderIcons ? (i(), g(b, { key: 0 })) : d("", !0),
        p("div", {
          class: a(t.value.wrapperFormCss)
        }, [
          C(N),
          t.value.renderBackgroundImage ? (i(), u("div", {
            key: 0,
            class: a(c.value.rootBackgroundImage),
            style: I(t.value.backgroundImageStyle)
          }, null, 6)) : d("", !0),
          p("form", jt, [
            t.value.hasLogo ? d("", !0) : (i(), u("div", Gt)),
            p("div", {
              class: a(c.value.container)
            }, [
              t.value.headerView === "basic" ? (i(), g(W, {
                key: 0,
                survey: t.value
              }, null, 8, ["survey"])) : d("", !0),
              (i(), g(T("sv-components-container"), {
                survey: t.value,
                container: "header",
                needRenderWrapper: !1
              }, null, 8, ["survey"])),
              t.value.isShowingPage ? (i(), u("div", {
                key: 1,
                class: a(t.value.bodyContainerCss)
              }, [
                (i(), g(T("sv-components-container"), {
                  survey: t.value,
                  container: "left",
                  needRenderWrapper: !0
                }, null, 8, ["survey"])),
                p("div", Jt, [
                  (i(), g(T("sv-components-container"), {
                    survey: t.value,
                    container: "center",
                    needRenderWrapper: !0
                  }, null, 8, ["survey"])),
                  p("div", {
                    class: a(t.value.bodyCss),
                    style: I({ maxWidth: t.value.renderedWidth }),
                    id: l.value
                  }, [
                    (i(), g(T("sv-components-container"), {
                      survey: t.value,
                      container: "contentTop",
                      needRenderWrapper: !0
                    }, null, 8, ["survey"])),
                    (i(), g(V, {
                      key: q.value,
                      survey: t.value,
                      page: t.value.activePage,
                      css: c.value
                    }, null, 8, ["survey", "page", "css"])),
                    (i(), g(T("sv-components-container"), {
                      survey: t.value,
                      container: "contentBottom",
                      needRenderWrapper: !0
                    }, null, 8, ["survey"]))
                  ], 14, Xt)
                ]),
                (i(), g(T("sv-components-container"), {
                  survey: t.value,
                  container: "right",
                  needRenderWrapper: !0
                }, null, 8, ["survey"]))
              ], 2)) : d("", !0),
              (i(), g(T("sv-components-container"), {
                survey: t.value,
                container: "footer",
                needRenderWrapper: !1
              }, null, 8, ["survey"])),
              v.value ? (i(), u("div", Yt, [
                p("div", {
                  innerHTML: f(),
                  class: a(t.value.completedCss)
                }, null, 10, Zt),
                (i(), g(T("sv-components-container"), {
                  survey: t.value,
                  container: "completePage",
                  needRenderWrapper: !0
                }, null, 8, ["survey"]))
              ])) : d("", !0),
              t.value.state === "completedbefore" ? (i(), u("div", {
                key: 3,
                class: a(t.value.completedBeforeCss),
                innerHTML: t.value.processedCompletedBeforeHtml
              }, null, 10, xt)) : d("", !0),
              t.value.state === "loading" ? (i(), u("div", {
                key: 4,
                class: a(t.value.loadingBodyCss),
                innerHTML: t.value.processedLoadingHtml
              }, null, 10, ei)) : d("", !0),
              t.value.state === "empty" ? (i(), u("div", {
                key: 5,
                class: a(c.value.bodyEmpty)
              }, R(t.value.emptySurveyText), 3)) : d("", !0)
            ], 2)
          ]),
          t.value.showBrandInfo ? (i(), g(Q, { key: 1 })) : d("", !0),
          C(ue, {
            model: t.value.notifier
          }, null, 8, ["model"])
        ], 2)
      ], 6);
    };
  }
}), si = /* @__PURE__ */ h({
  __name: "Notifier",
  props: {
    model: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.model), (n, e) => {
      const o = y("sv-action-bar");
      return n.model.isDisplayed ? (i(), u("div", {
        key: 0,
        class: a(n.model.css),
        style: I({ visibility: n.model.active ? "visible" : "hidden" }),
        role: "alert",
        "aria-live": "polite"
      }, [
        p("span", null, R(n.model.message), 1),
        C(o, {
          model: n.model.actionBar
        }, null, 8, ["model"])
      ], 6)) : d("", !0);
    };
  }
}), ni = ["id", "readonly", "disabled", "value", "maxlength", "placeholder", "aria-label", "aria-required"], oi = { key: 1 }, ti = /* @__PURE__ */ h({
  __name: "QuestionOther",
  props: {
    question: {},
    commentClass: {}
  },
  setup(r) {
    return (s, n) => (i(), u("div", {
      class: a(s.question.getCommentAreaCss(!0))
    }, [
      s.question.isReadOnlyRenderDiv() ? d("", !0) : (i(), u("textarea", {
        key: 0,
        id: s.question.otherId,
        readonly: s.question.isInputReadOnly,
        disabled: s.question.isInputReadOnly,
        class: a(s.question.cssClasses.other || s.commentClass),
        value: s.question.otherValue,
        maxlength: s.question.getOthersMaxLength(),
        placeholder: s.question.otherPlaceholder,
        "aria-label": s.question.ariaLabel || s.question.a11y_input_ariaLabel,
        "aria-required": s.question.ariaRequired || s.question.a11y_input_ariaRequired,
        style: I({ resize: s.question.resizeStyle }),
        onChange: n[0] || (n[0] = (e) => {
          s.question.onOtherValueChange(e);
        }),
        onInput: n[1] || (n[1] = (e) => {
          s.question.onOtherValueInput(e);
        })
      }, null, 46, ni)),
      s.question.isReadOnlyRenderDiv() ? (i(), u("div", oi, R(s.question.otherValue), 1)) : d("", !0)
    ], 2));
  }
}), ii = ["disabled", "value", "title"], ri = /* @__PURE__ */ h({
  __name: "SurveyNavigationButton",
  props: {
    item: {}
  },
  setup(r) {
    const s = r, n = () => s.item.data && s.item.data.mouseDown();
    return B(() => s.item), (e, o) => e.item.visible ? (i(), u("input", {
      key: 0,
      type: "button",
      disabled: e.item.disabled,
      value: e.item.title,
      class: a(e.item.innerCss),
      title: e.item.getTooltip(),
      onMousedown: n,
      onClick: o[0] || (o[0] = (...t) => e.item.action && e.item.action(...t))
    }, null, 42, ii)) : d("", !0);
  }
}), ve = /* @__PURE__ */ h({
  __name: "PopupSurvey",
  props: {
    survey: {},
    isExpanded: { type: Boolean },
    allowClose: { type: Boolean },
    allowFullScreen: { type: Boolean },
    closeOnCompleteTimeout: {}
  },
  setup(r) {
    const s = r, n = U(), e = S(() => s.survey ? s.survey.getCss() : {});
    S(() => {
      var f;
      return (f = n.value) != null && f.isExpanded ? e.value.window.header.buttonCollapsed : e.value.window.header.buttonExpanded;
    }), S(() => {
      var f;
      return (f = n.value) == null ? void 0 : f.isExpanded;
    });
    const o = () => {
      n.value.changeExpandCollapse();
    }, t = () => {
      n.value.hide();
    }, l = () => {
      n.value.toggleFullScreen();
    }, m = () => "SurveyComponent", v = () => {
      n.value.onScroll();
    }, c = () => {
      let f = n.value.cssHeaderRoot;
      return n.value.isCollapsed && (f += " " + n.value.cssRootCollapsedMod), f;
    };
    B(() => n.value);
    const q = K(
      () => s.survey,
      (f) => {
        const k = new He(null, f);
        s.isExpanded !== void 0 && (k.isExpanded = s.isExpanded), s.closeOnCompleteTimeout !== void 0 && (k.closeOnCompleteTimeout = s.closeOnCompleteTimeout), s.allowClose !== void 0 && (k.allowClose = s.allowClose), s.allowFullScreen !== void 0 && (k.allowFullScreen = s.allowFullScreen), k.isShowing = !0, n.value = k;
      },
      {
        immediate: !0
      }
    );
    return O(() => {
      q();
    }), (f, k) => {
      const L = y("sv-svg-icon");
      return n.value.isShowing ? (i(), u("div", {
        key: 0,
        style: I({ maxWidth: n.value.renderedWidth, width: n.value.renderedWidth }),
        class: a(n.value.cssRoot),
        onScroll: v
      }, [
        p("div", {
          class: a(n.value.cssRootContent)
        }, [
          p("div", {
            class: a(c())
          }, [
            n.value.isCollapsed && !!n.value.locTitle ? (i(), u("div", {
              key: 0,
              class: a(n.value.cssHeaderTitleCollapsed)
            }, R(n.value.locTitle.renderedHtml), 3)) : d("", !0),
            p("div", {
              class: a(n.value.cssHeaderButtonsContainer)
            }, [
              n.value.allowFullScreen ? (i(), u("div", {
                key: 0,
                class: a(n.value.cssHeaderFullScreenButton),
                onClick: l
              }, [
                n.value.isFullScreen ? (i(), g(L, {
                  key: 0,
                  iconName: "icon-back-to-panel_16x16",
                  size: 16
                })) : d("", !0),
                n.value.isFullScreen ? d("", !0) : (i(), g(L, {
                  key: 1,
                  iconName: "icon-full-screen_16x16",
                  size: 16
                }))
              ], 2)) : d("", !0),
              p("div", {
                class: a(n.value.cssHeaderCollapseButton),
                onClick: o
              }, [
                n.value.isExpanded ? (i(), g(L, {
                  key: 0,
                  iconName: "icon-minimize_16x16",
                  size: 16
                })) : d("", !0),
                n.value.isCollapsed ? (i(), g(L, {
                  key: 1,
                  iconName: "icon-restore_16x16",
                  size: 16
                })) : d("", !0)
              ], 2),
              n.value.allowClose ? (i(), u("div", {
                key: 1,
                class: a(n.value.cssHeaderCloseButton),
                onClick: t
              }, [
                C(L, {
                  iconName: "icon-close_16x16",
                  size: 16
                })
              ], 2)) : d("", !0)
            ], 2)
          ], 2),
          p("div", {
            class: a(n.value.cssBody)
          }, [
            (i(), g(T(m()), { survey: f.survey }, null, 8, ["survey"]))
          ], 2)
        ], 2)
      ], 38)) : d("", !0);
    };
  }
}), li = ["innerHTML"], ai = /* @__PURE__ */ h({
  __name: "CustomWidget",
  props: {
    question: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(), e = S(
      () => s.question.customWidget.isDefaultRender
    ), o = S(
      () => !!s.question.customWidget.htmlTemplate
    ), t = S(() => s.question.customWidget.htmlTemplate), l = S(() => "survey-" + s.question.getTemplate());
    return M(() => {
      s.question.customWidget.afterRender(s.question, n.value);
    }), G(() => {
      s.question.customWidget.willUnmount(s.question, n.value);
    }), (m, v) => (i(), u("div", {
      ref_key: "root",
      ref: n
    }, [
      o.value ? (i(), u("div", {
        key: 0,
        innerHTML: t.value
      }, null, 8, li)) : d("", !0),
      e.value ? (i(), g(T(l.value), {
        key: 1,
        question: m.question,
        css: m.css
      }, null, 8, ["question", "css"])) : d("", !0)
    ], 512));
  }
}), ui = /* @__PURE__ */ h({
  __name: "PopupModal",
  setup(r) {
    const s = U();
    function n(o, t, l, m, v, c, q = "popup") {
      const f = We(
        o,
        t,
        l,
        m,
        void 0,
        void 0,
        v,
        c,
        q
      );
      return e(f);
    }
    function e(o, t) {
      const l = Ve(
        o,
        t
      ), m = (v, c) => {
        c.isVisible || (s.value = void 0, l.dispose(), l.onVisibilityChanged.remove(m));
      };
      return l.onVisibilityChanged.add(m), l.model.isVisible = !0, s.value = l, l;
    }
    return j.showModal || (j.showModal = n, O(() => {
      j.showModal = void 0;
    })), j.showDialog || (j.showDialog = e, O(() => {
      j.showDialog = void 0;
    })), (o, t) => {
      const l = y("sv-popup-container");
      return s.value ? (i(), g(Re, {
        key: 0,
        to: s.value.container
      }, [
        C(l, { model: s.value }, null, 8, ["model"])
      ], 8, ["to"])) : d("", !0);
    };
  }
}), di = /* @__PURE__ */ h({
  __name: "CharacterCounter",
  props: {
    counter: {},
    remainingCharacterCounter: {}
  },
  setup(r) {
    const s = r;
    return B(() => s.counter), (n, e) => (i(), u("div", {
      class: a(n.remainingCharacterCounter)
    }, R(n.counter.remainingCharacterCounter), 3));
  }
}), mi = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Composite",
  props: {
    question: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = S(() => s.question.contentPanel);
    return (o, t) => {
      const l = y("survey-panel");
      return i(), g(l, {
        ref_key: "root",
        ref: n,
        element: e.value,
        css: o.css
      }, null, 8, ["element", "css"]);
    };
  }
}), ci = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Custom",
  props: {
    question: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(null);
    A(s, n);
    const e = S(() => s.question.contentQuestion), o = (t) => re(t);
    return (t, l) => (i(), g(T(o(e.value)), {
      ref: n.value,
      question: e.value,
      css: t.css
    }, null, 8, ["question", "css"]));
  }
}), pi = /* @__PURE__ */ p("use", { "xlink:href": "#icon-timercircle" }, null, -1), vi = [
  pi
], qe = 440, qi = /* @__PURE__ */ h({
  __name: "TimerPanel",
  props: {
    model: {},
    css: {}
  },
  setup(r) {
    const s = r, n = S(() => qe * s.model.progress), e = S(() => s.model.text);
    return B(() => s.model), (o, t) => o.model.isRunning && o.model.showTimerAsClock ? (i(), u("div", {
      key: 0,
      class: a(o.model.rootCss)
    }, [
      o.model.showProgress ? (i(), u("svg", {
        key: 0,
        class: a(o.model.getProgressCss()),
        style: I({ strokeDasharray: qe, strokeDashoffset: n.value })
      }, vi, 6)) : d("", !0),
      p("div", {
        class: a(o.model.textContainerCss)
      }, [
        p("span", {
          class: a(o.model.majorTextCss)
        }, R(o.model.clockMajorText), 3),
        o.model.clockMinorText ? (i(), u("span", {
          key: 0,
          class: a(o.model.minorTextCss)
        }, R(o.model.clockMinorText), 3)) : d("", !0)
      ], 2)
    ], 2)) : P((i(), u("div", {
      key: 1,
      class: a(o.model.survey.getCss().timerRoot)
    }, R(e.value), 3)), [
      [E, o.model.isRunning && !o.model.showTimerAsClock]
    ]);
  }
}), yi = {}, gi = { class: "sd-loading-indicator" };
function hi(r, s) {
  const n = y("sv-svg-icon");
  return i(), u("div", gi, [
    C(n, {
      iconName: "icon-loading",
      size: "'auto'"
    })
  ]);
}
const Ci = /* @__PURE__ */ he(yi, [["render", hi]]), bi = { key: 2 }, ki = /* @__PURE__ */ h({
  __name: "Header",
  props: {
    model: {},
    survey: {}
  },
  setup(r) {
    const s = r;
    return B(() => {
      const n = s.model;
      return n.survey = s.survey, s.model;
    }), (n, e) => {
      const o = y("sv-header-cell"), t = y("sv-header-mobile");
      return i(), u("div", {
        class: a(n.model.headerClasses),
        style: I({ height: n.model.renderedHeight })
      }, [
        n.model.backgroundImage ? (i(), u("div", {
          key: 0,
          class: a(n.model.backgroundImageClasses),
          style: I(n.model.backgroundImageStyle)
        }, null, 6)) : d("", !0),
        n.survey.isMobile ? d("", !0) : (i(), u("div", {
          key: 1,
          class: a(n.model.contentClasses),
          style: I({ maxWidth: n.model.maxWidth })
        }, [
          (i(!0), u(_, null, D(n.model.cells, (l, m) => (i(), g(o, {
            model: l,
            key: m
          }, null, 8, ["model"]))), 128))
        ], 6)),
        n.survey.isMobile ? (i(), u("div", bi, [
          C(t, { model: n.model }, null, 8, ["model"])
        ])) : d("", !0)
      ], 6);
    };
  }
}), fi = {
  key: 0,
  class: "sv-header__logo"
}, wi = ["src", "width", "height", "alt"], Ii = /* @__PURE__ */ h({
  __name: "HeaderCell",
  props: {
    model: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("survey-element-title"), o = y("survey-string");
      return i(), u("div", {
        class: a(s.model.css),
        style: I(s.model.style)
      }, [
        p("div", {
          class: "sv-header__cell-content",
          style: I(s.model.contentStyle)
        }, [
          s.model.showLogo ? (i(), u("div", fi, [
            p("div", {
              class: a(s.model.survey.logoClassNames)
            }, [
              p("img", {
                class: a(s.model.survey.css.logoImage),
                src: s.model.survey.locLogo.renderedHtml,
                width: s.model.survey.renderedLogoWidth,
                height: s.model.survey.renderedLogoHeight,
                alt: s.model.survey.locTitle.renderedHtml,
                style: I({ objectFit: s.model.survey.logoFit, width: s.model.survey.renderedStyleLogoWidth, height: s.model.survey.renderedStyleLogoHeight })
              }, null, 14, wi)
            ], 2)
          ])) : d("", !0),
          s.model.showTitle ? (i(), u("div", {
            key: 1,
            class: "sv-header__title",
            style: I({ maxWidth: s.model.textAreaWidth })
          }, [
            C(e, {
              element: s.model.survey,
              css: s.model.survey.css
            }, null, 8, ["element", "css"])
          ], 4)) : d("", !0),
          s.model.showDescription ? (i(), u("div", {
            key: 2,
            class: "sv-header__description",
            style: I({ maxWidth: s.model.textAreaWidth })
          }, [
            s.model.survey.renderedHasDescription ? (i(), u("div", {
              key: 0,
              class: a(s.model.survey.css.description)
            }, [
              C(o, {
                locString: s.model.survey.locDescription
              }, null, 8, ["locString"])
            ], 2)) : d("", !0)
          ], 4)) : d("", !0)
        ], 4)
      ], 6);
    };
  }
}), Si = { class: "sv-header--mobile" }, Ri = {
  key: 0,
  class: "sv-header__logo"
}, Ti = ["src", "width", "height", "alt"], $i = /* @__PURE__ */ h({
  __name: "HeaderMobile",
  props: {
    model: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("survey-element-title"), o = y("survey-string");
      return i(), u("div", Si, [
        s.model.survey.hasLogo ? (i(), u("div", Ri, [
          p("div", {
            class: a(s.model.survey.logoClassNames)
          }, [
            p("img", {
              class: a(s.model.survey.css.logoImage),
              src: s.model.survey.locLogo.renderedHtml,
              width: s.model.survey.renderedLogoWidth,
              height: s.model.survey.renderedLogoHeight,
              alt: s.model.survey.locTitle.renderedHtml,
              style: I({ objectFit: s.model.survey.logoFit, width: s.model.survey.renderedStyleLogoWidth, height: s.model.survey.renderedStyleLogoHeight })
            }, null, 14, Ti)
          ], 2)
        ])) : d("", !0),
        s.model.survey.hasTitle ? (i(), u("div", {
          key: 1,
          class: "sv-header__title",
          style: I({ maxWidth: s.model.renderedtextAreaWidth })
        }, [
          C(e, {
            element: s.model.survey,
            css: s.model.survey.css
          }, null, 8, ["element", "css"])
        ], 4)) : d("", !0),
        s.model.survey.renderedHasDescription ? (i(), u("div", {
          key: 2,
          class: "sv-header__description",
          style: I({ maxWidth: s.model.renderedtextAreaWidth })
        }, [
          s.model.survey.renderedHasDescription ? (i(), u("div", {
            key: 0,
            class: a(s.model.survey.css.description)
          }, [
            C(o, {
              locString: s.model.survey.locDescription
            }, null, 8, ["locString"])
          ], 2)) : d("", !0)
        ], 4)) : d("", !0)
      ]);
    };
  }
}), _i = /* @__PURE__ */ h({
  __name: "Element",
  props: {
    element: {},
    row: {},
    css: {}
  },
  setup(r) {
    const s = r, n = $(), e = (v) => v.isPanel ? "survey-panel" : "survey-question", o = S(() => {
      const v = s.element.survey;
      if (v) {
        const c = v.getElementWrapperComponentName(s.element);
        if (c)
          return c;
      }
      return e(s.element);
    }), t = (v) => v.cssClasses ? v.rootStyle : {}, l = S(() => {
      const v = s.element, c = v.survey;
      let q;
      return c && (q = c.getElementWrapperComponentData(v)), {
        componentName: e(v),
        componentData: {
          element: v,
          survey: c,
          row: s.row,
          css: s.css,
          data: q
        }
      };
    }), m = K(
      () => s.element,
      (v, c) => {
        c && c.setWrapperElement(void 0), v.setWrapperElement(n.value);
      }
    );
    return M(() => {
      s.element.setWrapperElement(n.value);
    }), O(() => {
      s.element.setWrapperElement(void 0), m();
    }), (v, c) => (i(), u("div", {
      ref_key: "root",
      ref: n,
      style: I(t(v.element)),
      class: a(v.element.cssClasses.questionWrapper)
    }, [
      v.row.isNeedRender ? (i(), g(T(o.value), z(H({ key: 0 }, l.value)), null, 16)) : v.element.skeletonComponentName ? (i(), g(T(v.element.skeletonComponentName), {
        key: 1,
        element: v.element,
        css: v.css
      }, null, 8, ["element", "css"])) : d("", !0)
    ], 6));
  }
}), Di = /* @__PURE__ */ h({
  __name: "TemplateRenderer",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(r) {
    const s = Te(), n = S(() => !!s.default);
    return (e, o) => n.value && !e.componentName ? $e(e.$slots, "default", { key: 0 }) : (i(), g(T(e.componentName), z(H({ key: 1 }, e.componentData)), null, 16));
  }
}), Bi = /* @__PURE__ */ h({
  __name: "FileCleanButton",
  props: {
    question: {},
    css: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("sv-svg-icon");
      return i(), u("button", {
        type: "button",
        class: a(s.css),
        onClick: n[0] || (n[0] = (...o) => s.question.doClean && s.question.doClean(...o))
      }, [
        p("span", null, R(s.question.clearButtonCaption), 1),
        s.question.cssClasses.removeButtonIconId ? (i(), g(e, {
          key: 0,
          iconName: s.question.cssClasses.removeButtonIconId,
          size: "auto",
          title: s.question.clearButtonCaption
        }, null, 8, ["iconName", "title"])) : d("", !0)
      ], 2);
    };
  }
}), Li = ["id"], Ni = /* @__PURE__ */ h({
  __name: "FileVideo",
  props: {
    question: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("sv-action");
      return i(), u("div", {
        class: a(s.question.cssClasses.videoContainer)
      }, [
        C(e, {
          item: s.question.changeCameraAction
        }, null, 8, ["item"]),
        C(e, {
          item: s.question.closeCameraAction
        }, null, 8, ["item"]),
        p("video", {
          autoplay: "",
          playsinline: "",
          id: s.question.videoId,
          class: a(s.question.cssClasses.video)
        }, null, 10, Li),
        C(e, {
          item: s.question.takePictureAction
        }, null, 8, ["item"])
      ], 2);
    };
  }
}), Pi = ["for", "aria-label"], Ai = /* @__PURE__ */ h({
  __name: "FileChooseButton",
  props: {
    data: {},
    item: {}
  },
  setup(r) {
    const s = r, n = S(
      () => {
        var e;
        return ((e = s.data) == null ? void 0 : e.question) || s.item.data.question;
      }
    );
    return (e, o) => {
      const t = y("sv-svg-icon"), l = X("key2click");
      return P((i(), u("label", {
        tabindex: "0",
        class: a(n.value.getChooseFileCss()),
        for: n.value.inputId,
        "aria-label": n.value.chooseButtonText,
        onClick: o[0] || (o[0] = (m) => n.value.chooseFile(m))
      }, [
        n.value.cssClasses.chooseFileIconId ? (i(), g(t, {
          key: 0,
          title: n.value.chooseButtonText,
          iconName: n.value.cssClasses.chooseFileIconId,
          size: "auto"
        }, null, 8, ["title", "iconName"])) : d("", !0),
        p("span", null, R(n.value.chooseButtonText), 1)
      ], 10, Pi)), [
        [l]
      ]);
    };
  }
}), Mi = ["onClick", "href", "title", "download"], Ei = ["src"], Hi = ["onClick"], Wi = ["onClick", "href", "title", "download"], Vi = /* @__PURE__ */ h({
  __name: "FilePreview",
  props: {
    question: {}
  },
  setup(r) {
    return (s, n) => {
      const e = y("sv-svg-icon");
      return s.question.showPreviewContainer ? (i(), u("div", {
        key: 0,
        class: a(s.question.cssClasses.fileList || void 0)
      }, [
        (i(!0), u(_, null, D(s.question.previewValue, (o, t) => P((i(), u("span", {
          key: s.question.inputId + "_" + t,
          class: a(s.question.cssClasses.previewItem)
        }, [
          o.name && s.question.cssClasses.fileSign ? (i(), u("div", {
            key: 0,
            class: a(s.question.cssClasses.fileSign)
          }, [
            p("a", {
              onClick: (l) => s.question.doDownloadFile(l, o),
              href: o.content,
              title: o.name,
              download: o.name,
              style: I({ width: s.question.imageWidth })
            }, R(o.name), 13, Mi)
          ], 2)) : d("", !0),
          p("div", {
            class: a(s.question.getImageWrapperCss(o))
          }, [
            s.question.canPreviewImage(o) ? (i(), u("img", {
              key: 0,
              src: o.content,
              style: I({
                height: s.question.imageHeight,
                width: s.question.imageWidth
              }),
              alt: "File preview"
            }, null, 12, Ei)) : d("", !0),
            s.question.defaultImage(o) ? (i(), g(e, {
              key: 1,
              iconName: s.question.cssClasses.defaultImageIconId,
              class: a(s.question.cssClasses.defaultImage),
              size: "auto"
            }, null, 8, ["iconName", "class"])) : d("", !0),
            o.name && !s.question.isReadOnly ? (i(), u("div", {
              key: 2,
              class: a(s.question.getRemoveButtonCss()),
              onClick: (l) => s.question.doRemoveFile(o)
            }, [
              p("span", {
                class: a(s.question.cssClasses.removeFile)
              }, R(s.question.removeFileCaption), 3),
              s.question.cssClasses.removeFileSvgIconId ? (i(), g(e, {
                key: 0,
                title: s.question.removeFileCaption,
                class: a(s.question.cssClasses.removeFileSvg),
                iconName: s.question.cssClasses.removeFileSvgIconId,
                size: "auto"
              }, null, 8, ["title", "class", "iconName"])) : d("", !0)
            ], 10, Hi)) : d("", !0)
          ], 2),
          o.name && s.question.cssClasses.fileSignBottom ? (i(), u("div", {
            key: 1,
            class: a(s.question.cssClasses.fileSignBottom)
          }, [
            p("a", {
              onClick: (l) => s.question.doDownloadFile(l, o),
              href: o.content,
              title: o.name,
              download: o.name,
              style: I({ width: s.question.imageWidth })
            }, R(o.name), 13, Wi)
          ], 2)) : d("", !0)
        ], 2)), [
          [E, o && s.question.isPreviewVisible(t)]
        ])), 128))
      ], 2)) : d("", !0);
    };
  }
}), Fi = /* @__PURE__ */ h({
  __name: "ButtonGroup",
  props: {
    question: {}
  },
  setup(r) {
    const s = r, n = $();
    return A(s, n), (e, o) => {
      const t = y("sv-button-group-item");
      return i(), u("div", {
        role: "group",
        class: a(e.question.cssClasses.root),
        ref_key: "root",
        ref: n
      }, [
        (i(!0), u(_, null, D(e.question.visibleChoices, (l, m) => (i(), g(t, {
          question: e.question,
          key: m,
          item: l,
          index: m
        }, null, 8, ["question", "item", "index"]))), 128))
      ], 2);
    };
  }
}), Oi = ["title"], zi = ["name", "id", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "disabled", "value"], Ui = ["title"], Ki = /* @__PURE__ */ h({
  __name: "ButtonGroupItem",
  props: {
    item: {},
    question: {},
    index: {}
  },
  setup(r) {
    const s = r, n = S(
      () => new Fe(s.question, s.item, s.index)
    ), e = S({
      get: () => s.question.renderedValue,
      set: (o) => {
        const t = s.question;
        t.renderedValue = o;
      }
    });
    return (o, t) => {
      const l = y("sv-svg-icon"), m = y("survey-string");
      return i(), u("label", {
        role: "radio",
        class: a(n.value.css.label),
        title: n.value.caption.renderedHtml
      }, [
        P(p("input", {
          type: "radio",
          name: n.value.name,
          id: n.value.id,
          "aria-required": n.value.isRequired,
          "aria-label": n.value.caption.renderedHtml,
          role: "radio",
          "aria-invalid": n.value.hasErrors,
          "aria-errormessage": n.value.describedBy,
          disabled: n.value.readOnly,
          class: a(n.value.css.control),
          "onUpdate:modelValue": t[0] || (t[0] = (v) => e.value = v),
          value: n.value.value
        }, null, 10, zi), [
          [x, e.value]
        ]),
        p("div", {
          class: a(n.value.css.decorator)
        }, [
          n.value.iconName ? (i(), g(l, {
            key: 0,
            iconName: n.value.iconName,
            size: n.value.iconSize,
            class: a(n.value.css.icon)
          }, null, 8, ["iconName", "size", "class"])) : d("", !0),
          n.value.showCaption ? (i(), u("span", {
            key: 1,
            class: a(n.value.css.caption),
            title: n.value.caption.renderedHtml
          }, [
            C(m, {
              locString: n.value.caption
            }, null, 8, ["locString"])
          ], 10, Ui)) : d("", !0)
        ], 2)
      ], 10, Oi);
    };
  }
}), Qi = ["src", "width", "height", "alt"], ji = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Logo",
  props: {
    data: {}
  },
  setup(r) {
    const s = r, n = S(() => s.data), e = J(() => n.value.locLogo);
    return (o, t) => (i(), u("div", {
      class: a(n.value.logoClassNames)
    }, [
      p("img", {
        class: a(n.value.css.logoImage),
        src: w(e),
        width: n.value.renderedLogoWidth,
        height: n.value.renderedLogoHeight,
        alt: n.value.locTitle.renderedHtml,
        style: I({
          objectFit: n.value.logoFit,
          width: n.value.renderedStyleLogoWidth,
          height: n.value.renderedStyleLogoHeight
        })
      }, null, 14, Qi)
    ], 2));
  }
}), Gi = /* @__PURE__ */ h({
  __name: "SvgBundle",
  setup(r) {
    const s = $();
    return M(() => {
      s.value.innerHTML = Oe.iconsRenderedHtml();
    }), (n, e) => P((i(), u("svg", {
      id: "sv-icon-holder-global-container",
      ref_key: "root",
      ref: s
    }, null, 512)), [
      [E, !1]
    ]);
  }
});
ze.platform = "vue3";
function Ji(r) {
  r.component("SurveyComponent", pe), r.component("sv-svg-bundle", Gi), r.component("PopupSurveyComponent", ve), r.component("survey", pe), r.component("popup-survey", ve), r.component("survey-header", Ge), r.component("sv-logo-image", ji), r.component("survey-page", je), r.component("survey-row", Je), r.component("survey-question", xe), r.component("survey-panel", os), r.component("survey-element-header", is), r.component("survey-string", rs), r.component("sv-string-viewer", as), r.component("sv-string-editor", ds), r.component("sv-skeleton", cs), r.component("survey-text", qs), r.component("survey-text-input", hs), r.component("survey-checkbox", ws), r.component("survey-checkbox-item", Rs), r.component("survey-radiogroup", Ts), r.component("survey-radiogroup-item", Ds), r.component("survey-signaturepad", Ps), r.component("survey-html", Ms), r.component("survey-image", Vs), r.component("survey-expression", Fs), r.component("survey-file", Us), r.component("sv-file-choose-btn", Ai), r.component("sv-file-clean-btn", Bi), r.component("sv-file-preview", Vi), r.component("sv-file-video", Ni), r.component("survey-imagepicker", Qs), r.component("survey-imagepicker-item", Ys), r.component("survey-comment", en), r.component("survey-dropdown", sn), r.component("sv-dropdown-select", rn), r.component("sv-dropdown-option-item", an), r.component("sv-dropdown", pn), r.component("survey-tagbox", vn), r.component("sv-tagbox", gn), r.component("sv-tagbox-item", fn), r.component("sv-tagbox-filter", bn), r.component("survey-ranking", wn), r.component("survey-ranking-item", _n), r.component("survey-rating", Ln), r.component("sv-rating-item", Pn), r.component("sv-rating-item-smiley", Mn), r.component("sv-rating-item-star", Hn), r.component("sv-rating-dropdown", zn), r.component("sv-rating-dropdown-item", On), r.component("survey-boolean", Kn), r.component("sv-boolean-radio", Qn), r.component("sv-boolean-radio-item", Jn), r.component("sv-boolean-checkbox", so), r.component("survey-multipletext", no), r.component("survey-multipletext-item", to), r.component("survey-matrix", mo), r.component("survey-matrix-row", po), r.component("survey-matrix-cell", yo), r.component("survey-matrixdropdown", go), r.component("survey-matrixtable", bo), r.component("survey-matrixheaderrequired", fo), r.component("survey-matrixdropdown-cell", Io), r.component("survey-matrixdynamic", So), r.component("sv-matrix-remove-button", To), r.component("sv-matrix-drag-drop-icon", _o), r.component("sv-matrix-detail-button", Bo), r.component("survey-paneldynamic", Lo), r.component("survey-paneldynamicprogress", No), r.component("survey-paneldynamicprogress-v2", Po), r.component("sv-paneldynamic-add-btn", Ao), r.component("sv-paneldynamic-next-btn", Eo), r.component("sv-paneldynamic-prev-btn", Wo), r.component("sv-paneldynamic-remove-btn", Vo), r.component("sv-paneldynamic-progress-text", Fo), r.component("sv-components-container", Wt), r.component("sv-progress-buttons", Kt), r.component("sv-navigation-toc", Qt), r.component("sv-progress-pages", Z), r.component("sv-progress-questions", Z), r.component("sv-progress-correctquestions", Z), r.component("sv-progress-requiredquestions", Z), r.component("survey-errors", zo), r.component("survey-question-comment", Qo), r.component("survey-element-title", jo), r.component("survey-element-title-content", Yo), r.component("sv-title-actions", et), r.component("sv-brand-info", rt), r.component("sv-question-error", dt), r.component("sv-svg-icon", ut), r.component("sv-action-bar", mt), r.component("sv-action", vt), r.component("sv-action-bar-item", gt), r.component("sv-action-bar-item-dropdown", bt), r.component("sv-action-bar-separator", kt), r.component("sv-list", St), r.component("sv-list-item", $t), r.component("sv-popup", _t), r.component("sv-popup-container", Mt), r.component("popup-pointer", Et), r.component("sv-notifier", si), r.component("survey-other-choice", ti), r.component("sv-nav-btn", ri), r.component("survey-customwidget", ai), r.component("survey-popup-modal", ui), r.component("sv-character-counter", di), r.component("survey-composite", mi), r.component("survey-custom", ci), r.component("sv-timerpanel", qi), r.component("sv-loading-indicator", Ci), r.component("sv-header", ki), r.component("sv-header-cell", Ii), r.component("sv-header-mobile", $i), r.component("sv-template-renderer", Di), r.component("survey-element", _i), r.component("survey-buttongroup", Fi), r.component("sv-button-group-item", Ki), r.directive("key2click", {
    mounted: function(s, n) {
      const e = { ...n.value };
      if (e.disableTabStop) {
        s.tabIndex = -1;
        return;
      }
      e.disableTabStop || (s.tabIndex = 0), s.addEventListener("keyup", (o) => (o.preventDefault(), o.stopPropagation(), ye(o, e), !1)), s.addEventListener("keydown", (o) => {
        Ue(o, e);
      }), s.addEventListener("blur", (o) => {
        Ke(o);
      });
    }
  });
}
const Zi = {
  install(r) {
    Ji(r);
  }
};
export {
  Zi as surveyPlugin,
  B as useBase,
  le as useComputedArray,
  J as useLocString,
  A as useQuestion
};
